/* eslint-disable max-len */
import { colors } from '../colors';
import { FILTER_KEYS, YEARS } from './filters';

export const PERFORMANCE = 'performance';
export const MANAGE = 'manage';
export const GAME_MANAGE = 'game_manage';
export const METRICS = 'metrics';
export const FLIGHTS = 'flights';
export const REPORT = 'report';
export const COMBINE = 'combine';
export const EVENT_LOGGER = 'event';
export const BALL = 'ball';
export const BALL_JERSEY = 'B';
export const MAP = 'map';
export const PRACTICE_TRACKING = 'tracking';
export const EXPANDED = 'expanded';
export const BY_PERIOD = 'metrics';
export const CONDENSED = 'condensed';
export const MONTH = 'month';
export const WEEK = 'week';
export const WEEKS = 'weeks';
export const ALL = 'All';
export const GAMES = 'games';
export const PRACTICES = 'practices';
export const GAME = 'game';
export const PRACTICE = 'practice';
export const LIVE = 'live';
export const PAST = 'post';
export const FUTURE = 'future';
export const UNASSIGNED = 'unassigned';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const NUMBER_OF_WEEK_DAYS = 7;
export const LOAD_TODAY_EVENTS_TIME_SCHEDULE = 5000;
export const LOAD_EVENTS_TIME_LIVE_PAGE = 15000;
export const LOAD_MONITOR_DATA_TIME = 15000;
export const LOAD_DATAOPS_TIME = 5000;
export const MINUTES_WAITING_DATA_TIME = 30;
export const SEASON_WEEK = [
                          'Week P1',
                          'Week P2',
                          'Week P3',
                          'Week P4',
                          'Week 1',
                          'Week 2',
                          'Week 3',
                          'Week 4',
                          'Week 5',
                          'Week 6',
                          'Week 7',
                          'Week 8',
                          'Week 9',
                          'Week 10',
                          'Week 11',
                          'Week 12',
                          'Week 13',
                          'Week 14',
                          'Week 15',
                          'Week 16',
                          'Week 17',
                          'Wild Card',
                          'Divisional Round',
                          'Conference Championship',
                          'Super Bowl'
];
export const ALL_SEASON_YEAR = 'ALL_SEASON_YEAR';
export const CUSTOM = 'CUSTOM';
export const VIEW_BY_PLAYER = 'byPlayer';
export const VIEW_SPEED_ZONE = 'speedZone';
export const NO_FILTER = 'No Filter';
export const EMPTY_TEXT = '';
export const LEFT = 'left';
export const RIGHT = 'right';
export const CENTER = 'center';
export const DONE = 'done';
export const FAILED = 'failed';
export const LOADING = 'loading';
export const NFL = 'nfl';
export const NCAA = 'ncaa';
export const TEAM = 'Team';
export const NFC = 'NFC';
export const AFC = 'AFC';
export const PAST_PRACTICE = 'pastPractice';
export const LIVE_PRACTICE = 'livePractice';
export const FUTURE_PRACTICE = 'futurePractice';
export const PAST_GAME = 'pastGame';
export const FINISH = 'FINISH';
export const NFL_GAME = 'NFL Game';
export const NCAA_FBS_GAME = 'NCAA-FBS Game';
export const MESSAGES = {
  EMPTY: 'No data matches your specified criteria',
  DATA_IS_BEING_REPROCESSED: 'Data is being processed',
  NO_DATA_FOUND: 'No data found, trying again in a few seconds.',
  EMPTY_BALL_FLIGHTS: 'No ball flights were tracked during this session.',
  EMPTY_BALL_FLIGHTS_LIVE: 'No ball flights have been tracked during the session.',
  NO_ENTITIES_HEALTH: 'No tags/entities are located at this time'
};

export const S_B_ROLES = {
  TEAM_ADMIN: 'TeamAdmin',
  COMMAND_CENTER: 'CommandCenter',
  CUSTOMER: 'Customer',
  NCAA_ALL_SPORTS: 'NCAAAllSports'
};

export const TA_RESTRICTED_PAGES = [
  'entities', 'monitor', 'health', 'dataops', 'customers'
];

export const MOBILE_RESTRICTED =[
  'practices', 'games', 'players', 'entities', 'health', 'monitor', 'dataops', 'customers', 'profiles',
  'teams', 'about', 'status', 'view'
];

export const CUSTOMER_RESTRICTED_PAGES = [
  'profiles'
].concat(TA_RESTRICTED_PAGES);

export const NFL_EXCLUSIVE_PAGES = [
  'teams'
];

export const CUSTOM_SCOPES = {
  SCHEDULE: 'SCHEDULE',
  PERIOD_TYPE_PRACTICE_MANAGER_TAB: 'PERIOD_TYPE_PRACTICE_MANAGER_TAB',
  PERIOD_TYPE_PERIODS_LIST: 'PERIOD_TYPE_PERIODS_LIST',
  PERIOD_TYPE_PROFILE_LIST: 'PERIO_TYPE_PROFILE_LIST',
  STATUS_TRACKING_TAB: 'STATUS_TRACKING_TAB'
};

export const FLIGHT = {
  name: 'Flight',
  types: [
    { value: 'Pass', name: 'Pass' },
    { value: 'Kick', name: 'Kick' },
    { value: 'Punt', name: 'Punt' },
    { value: 'Long Snap', name: 'Long Snap' }
  ],
  title: 'FLIGHT TYPE',
  filterKey: FILTER_KEYS.FLIGHT_TYPE
};

export const PERIOD_TYPES = {
  name: 'Period Types',
  types: [
    { value: 'Pass', name: 'Pass' },
    { value: 'Kick/FGA', name: 'Kick' },
    { value: 'Punt', name: 'Punt' },
    { value: 'Long Snap', name: 'Long Snap' }
  ],
  title: 'PERIOD TYPES'
};

export const POSITION_LACROSSE = {
  name: 'Position',
  types: [
    { value: 'ATTACK', name: 'ATTACK' },
    { value: 'DEFENSE', name: 'DEFENSE' },
    { value: 'FO', name: 'FO' },
    { value: 'GOALIE', name: 'GOALIE' },
    { value: 'LSM', name: 'LSM' },
    { value: 'MIDFIELD', name: 'MIDFIELD' }
  ],
  title: 'POSITION',
  filterKey: FILTER_KEYS.POSITIONS
};
export const SPEED_ZONE_TYPE = {
  name: 'ZoneTypes',
  types: [
    { value: 'SPEED ZONE 1', name: 'Speed Zone 1' },
    { value: 'SPEED ZONE 2', name: 'Speed Zone 2' },
    { value: 'SPEED ZONE 3', name: 'Speed Zone 3' },
    { value: 'SPEED ZONE 4', name: 'Speed Zone 4' }
  ],
  title: 'ZONE TYPE',
  filterKey: FILTER_KEYS.SPEED_ZONE_TYPE
};

export const VIEW = {
  name: 'View',
  types: [
    { value: 'allData', name: 'All Data', paramValue: 'allData' },
    { value: 'Team Zone', name: 'Team Zone', paramValue: 'teamZone' },
    { value: 'Player Relative Zone', name: 'Player Relative Zone', paramValue: 'playerRelativeZone' },
    { value: 'Custom Zone', name: 'Custom Zone', paramValue: 'customZone' },
    { value: 'Timing and Pace', name: 'Timing and Pace', paramValue: 'timingAndPace' },
    { value: 'Accels and Decels', name: 'Accels and Decels', paramValue: 'accelsAndDecels' },
    { value: 'Load Metrics', name: 'Load Metrics', paramValue: 'loadMetrics' },
    { value: 'Zebra Team Summary', name: 'Zebra Team Summary', paramValue: 'zebraTeamSummary' },
    { value: 'Zebra Relative Summary', name: 'Zebra Relative Summary', paramValue: 'zebraRelativeSummary' },
    { value: 'Zebra Custom Summary', name: 'Zebra Custom Summary', paramValue: 'zebraCustomSummary' },
    { value: 'customView', name: 'Custom View', paramValue:'customView'}
  ],
  defaultIndex: 0,
  title: 'VIEW',
  filterKey: FILTER_KEYS.VIEW
};

export const VIEW_LIVE = {
  name: 'View',
  types: [
    { value: 'allData', name: 'All Data', paramValue: 'allData' },
    { value: 'customView', name: 'Custom View', paramValue:'customView'}
  ],
  defaultIndex: 0,
  title: 'VIEW',
  filterKey: FILTER_KEYS.VIEW_LIVE
};

export const SEASON_FILTER = {
  name: 'Season',
  types: [...YEARS].reverse().map(year => ({ value: year, name: `${year}-${year + 1}` })),
  defaultIndex: new Date().getMonth() < 2 ? 1 : 0,
  title: 'SEASON',
  filterKey: FILTER_KEYS.SEASON
};

export const PLAY_TYPE = {
  name: 'Play Type',
  types: [
    {
      value: {
        label: 'Totals',
        value: 'both',
        type: 'game'
      },
      name: 'Totals'
    },
    {
      value: {
        label: 'In-Play',
        value: 'in',
        type: 'game'
      },
      name: 'In-Play'
    },
    {
      value: {
        label: 'Out-Of-Play',
        value: 'out',
        type: 'game'
      },
      name: 'Out-Of-Play'
    },
    {
      value: {
        label: 'Pre-Game',
        value: 'both',
        type: 'game'
      },
      name: 'Pre-Game'
    }
  ],
  title: 'PLAY TYPE',
  defaultIndex: 0,
  filterKey: FILTER_KEYS.PLAY_TYPE
};

export const PLAY_TYPE_CC = {
  name: 'Play Type',
  types: [
    {
      value: {
        label: 'Totals',
        value: 'both',
        type: 'game'
      },
      name: 'Totals'
    },
    {
      value: {
        label: 'In-Play',
        value: 'in',
        type: 'game'
      },
      name: 'In-Play'
    },
    {
      value: {
        label: 'Out-Of-Play',
        value: 'out',
        type: 'game'
      },
      name: 'Out-Of-Play'
    }
  ],
  title: 'PLAY TYPE'
};

export const LEAGUE = {
  name: 'League',
  types: [
    {
      value: {
        label: 'NCAA-FBS Practice',
        value: 'ncaa-fbs',
        type: 'practice'
      },
      name: 'NCAA-FBS Practice'
    },
    {
      value: {
        label: 'NCAA-FBS Game',
        value: 'ncaa-fbs',
        type: 'game'
      },
      name: 'NCAA-FBS Game'
    },
    {
      value: {
        label: 'NFL Practice',
        value: 'nfl',
        type: 'practice'
      },
      name: 'NFL Practice'
    },
    {
      value: {
        label: 'NFL Game',
        value: 'nfl',
        type: 'game'
      },
      name: 'NFL Game'
    },
    {
      value: {
        label: 'NCAA-MLAX Practice',
        value: 'ncaa-mlax',
        type: 'practice'
      },
      name: 'NCAA-MLAX Practice'
    }
  ],
  defaultIndex: 2,
  title: 'LEAGUE',
  filterKey: FILTER_KEYS.LEAGUE
};

export const SIMPLE_LEAGUE = {
  name: 'League',
  types: [
    {
      value: {
        label: 'NCAA',
        value: 'ncaa',
        type: ''
      },
      name: 'NCAA'
    },
    {
      value: {
        label: 'NFL',
        value: 'nfl',
        type: ''
      },
      name: 'NFL'
    }
  ],
  defaultIndex: 1,
  title: 'LEAGUE',
  filterKey: FILTER_KEYS.SIMPLE_LEAGUE
};

export const LEAGUES = {
  NCAA: 'ncaa-fbs',
  NFL: 'nfl',
  MLAX: 'ncaa-mlax'
};

export const ZONE_TYPE = {
  name: 'Zone Type',
  types: ['Team', 'Player', 'Custom'],
  title: 'ZONE TYPE'
};

export const FIELD_TYPE = {
  name: 'Field Type',
  types: ['Indoor', 'Outdoor', 'Indoor/Outdoor', 'Stadium'],
  title: 'FIELD TYPE'
};

// Types of TIME SINCE X% OF MAX filter
export const NO_ZONE = 'No Zone';
export const TIME_SINCE_ZONE_TYPES = [
  {
    value: -1,
    name: NO_ZONE
  },
  { value: 0, name: 'Zone 1' },
  { value: 1, name: 'Zone 2' },
  { value: 2, name: 'Zone 3' },
  { value: 3, name: 'Zone 4' },
  { value: 4, name: 'Zone 5' }
];

export const PLAYER_NOTE_TYPES =[
  { value:'Full', name: 'Full' },
  { value: 'Modified', name: 'Modified' },
  { value: 'Rehab', name: 'Rehab' },
  { value: 'Partial/Limited', name: 'Partial/Limited' },
  { value: 'None', name: 'None' }
];
export const GAME_PLAYER_NOTE_TYPES =[
  { value: 'Probable', name: 'Probable' },
  { value: 'Questionable', name: 'Questionable' },
  { value: 'Doubtful', name: 'Doubtful' },
  { value:'Full', name: 'Full' },
  { value: 'Modified', name: 'Modified' },
  { value: 'Rehab', name: 'Rehab' },
  { value: 'Partial/Limited', name: 'Partial/Limited' },
  { value: 'None', name: 'None' }
];

export const PLAYER_NOTE_LETTER_AND_COLOR =[
  { value:'Full', letter: 'F', color:'green' },
  { value: 'Modified', letter: 'M', color: 'yellow' },
  { value: 'Rehab', letter: 'R', color: 'red' },
  { value: 'Partial/Limited', letter: 'L', color: 'orange' },
  { value: 'None', letter: '-', color: 'grey' },
  { value: 'Questionable', letter: 'Q', color: 'yellow' },
  { value: 'Doubtful', letter: 'D', color:'red' },
  { value: 'Probable', letter: 'P', color:'green' },
];
export const POSITION = {
  name: 'Position',
  types: [
    { name: 'QB',   value: { position: 'QB',  group: 'QB', unit: 'OFF' } },
    { name: 'RB',   value: { position: 'RB',  group: 'RB', unit: 'OFF' } },
    { name: 'FB',   value: { position: 'FB',  group: 'RB', unit: 'OFF' } },
    { name: 'WR',   value: { position: 'WR',  group: 'WR', unit: 'OFF' } },
    { name: 'WO',   value: { position: 'WO',  group: 'WO', unit: 'OFF' } },
    { name: 'TE',   value: { position: 'TE',  group: 'TE', unit: 'OFF' } },
    { name: 'OL',   value: { position: 'OL',  group: 'OL', unit: 'OFF' } },
    { name: 'T',    value: { position: 'T',   group: 'OL', unit: 'OFF' } },
    { name: 'OT',   value: { position: 'OT',  group: 'OL', unit: 'OFF' } },
    { name: 'G',    value: { position: 'G',   group: 'OL', unit: 'OFF' } },
    { name: 'OG',   value: { position: 'OG',  group: 'OL', unit: 'OFF' } },
    { name: 'C',    value: { position: 'C',   group: 'OL', unit: 'OFF' } },
    { name: 'OC',   value: { position: 'OC',  group: 'OL', unit: 'OFF' } },
    { name: 'DL',   value: { position: 'DL',  group: 'DL', unit: 'DEF' } },
    { name: 'DT',   value: { position: 'DT',  group: 'DL', unit: 'DEF' } },
    { name: 'IDL',  value: { position: 'IDL', group: 'DL', unit: 'DEF' } },
    { name: 'NT',   value: { position: 'NT',  group: 'DL', unit: 'DEF' } },
    { name: 'DE',   value: { position: 'DE',  group: 'DL', unit: 'DEF' } },
    { name: 'EDGE', value: { position: 'EDGE',group: 'DL', unit: 'DEF' } },
    { name: 'LB',   value: { position: 'LB',  group: 'LB', unit: 'DEF' } },
    { name: 'OLB',  value: { position: 'OLB', group: 'LB', unit: 'DEF' } },
    { name: 'MLB',  value: { position: 'MLB', group: 'LB', unit: 'DEF' } },
    { name: 'ILB',  value: { position: 'ILB', group: 'LB', unit: 'DEF' } },
    { name: 'MIKE', value: { position: 'MIKE',group: 'LB', unit: 'DEF' } },
    { name: 'WILL', value: { position: 'WILL',group: 'LB', unit: 'DEF' } },
    { name: 'SAM',  value: { position: 'SAM', group: 'LB', unit: 'DEF' } },
    { name: 'DB',   value: { position: 'DB',  group: 'DB', unit: 'DEF' } },
    { name: 'DS',   value: { position: 'DS',  group: 'DB', unit: 'DEF' } },
    { name: 'DC',   value: { position: 'DC',  group: 'DB', unit: 'DEF' } },
    { name: 'CB',   value: { position: 'CB',  group: 'DB', unit: 'DEF' } },
    { name: 'S',    value: { position: 'S',   group: 'DB', unit: 'DEF' } },
    { name: 'SAF',  value: { position: 'SAF', group: 'DB', unit: 'DEF' } },
    { name: 'FS',   value: { position: 'FS',  group: 'DB', unit: 'DEF' } },
    { name: 'SS',   value: { position: 'SS',  group: 'DB', unit: 'DEF' } },
    { name: 'STAR', value: { position: 'STAR',group: 'DB', unit: 'DEF' } },
    { name: 'K',    value: { position: 'K',   group: 'SPEC', unit: 'SPEC' } },
    { name: 'P',    value: { position: 'P',   group: 'SPEC', unit: 'SPEC' } },
    { name: 'PK',   value: { position: 'PK',  group: 'SPEC', unit: 'SPEC' } },
    { name: 'LS',   value: { position: 'LS',  group: 'SPEC', unit: 'SPEC' } }
  ],
  title: 'POSITION'
};

export const STATUS = {
  name: 'Status',
  types: [
    { name: 'ACT', value: 'ACT' },
    { name: 'DEV', value: 'DEV' },
    { name: 'RES', value: 'RES' },
    { name: 'PUP', value: 'PUP' },
    { name: 'RSN', value: 'RSN' },
    { name: 'UF', value: 'UF' },
    { name: 'CUT', value: 'CUT' },
    { name: 'EXE', value: 'EXE' },
    { name: 'NWT', value: 'NWT' }
  ],
  title: 'STATUS'
};

// constants for Date Range Selector component
export const USE_IN_PROGRESS_COMPS_DAYS = 28;
export const CURRENT_YEAR_LABEL = 'currentYear';
export const CUSTOM_LABEL = 'custom';
export const DATES_LABEL = 'dates';
export const PRACTICES_LABEL = 'practices';
export const SELECT_LABEL = 'Select';

export const SCOPE = {
  LOGIN: {
    PAGE: 'LOGIN_PAGE'
  },
  SCHEDULE: {
    WEEK: {
      PAGE: 'SCHEDULE_WEEK'
    },
    MONTH: {
      PAGE: 'SCHEDULE_MONTH'
    },
    scope: (path) => {
      switch (path) {
        case 'week':
          return SCOPE.SCHEDULE.WEEK.PAGE;
        case 'month':
          return SCOPE.SCHEDULE.MONTH.PAGE;
        default :
          return null;
      }
    },
    TODAY: 'TODAY'
  },
  ENTITIES: {
    PAGE: 'ENTITIES_PAGE',
    scope: (path) => {
      switch (path) {
        case 'noc':
          return SCOPE.ENTITIES.NOC.PAGE;
        case 'venues':
          return SCOPE.ENTITIES.VENUES.PAGE;
        default :
          return null;
      }
    },
    NOC: {
      PAGE: 'ENTITIES_NOC_PAGE'
    },
    VENUES: {
      PAGE: 'ENTITIES_VENUES_PAGE'
    }
  },
  PRACTICES: {
    PAGE: 'PRACTICES_PAGE'
  },
  PLAYERS: {
    PAGE: 'PLAYERS_PAGE'
  },
  PLAYER: {
    PRACTICES: {
      PAGE: 'PLAYER_PAGE_PRACTICES'
    },
    GAMES: {
      PAGE: 'PLAYER_PAGE_GAMES'
    },
    scope: (path) => {
      switch (path) {
        case 'practices':
          return SCOPE.PLAYER.PRACTICES.PAGE;
        case 'games':
          return SCOPE.PLAYER.GAMES.PAGE;
        default :
          return SCOPE.PLAYER;
      }
    }
  },
  GAMES: {
    PAGE: 'GAMES'
  },
  TEAM: {
    TEAM_PERFORMANCE: {
      scope: (path) => {
        switch (path) {
          case 'practices':
            return SCOPE.TEAM.TEAM_PERFORMANCE.PRACTICES.PAGE;
          case 'games':
            return SCOPE.TEAM.TEAM_PERFORMANCE.GAMES.PAGE;
          default :
            return SCOPE.TEAM;
        }
      },
      PRACTICES: {
        PAGE: 'TEAM_PERFORMANCE_PRACTICES_PAGE'
      },
      GAMES: {
        PAGE: 'TEAM_PERFORMANCE_GAMES_PAGE'
      }
    },
    PLAYER_PERFORMANCE: {
      scope: (path) => {
        switch (path) {
          case PRACTICES:
            return SCOPE.TEAM.PLAYER_PERFORMANCE.PRACTICES.PAGE;
          case GAMES:
            return SCOPE.TEAM.PLAYER_PERFORMANCE.GAMES.PAGE;
          default :
            return SCOPE.TEAM;
        }
      },
      PRACTICES: {
        PAGE: 'PLAYER_PERFORMANCE_PRACTICES_PAGE'
      },
      GAMES: {
        PAGE: 'PLAYER_PERFORMANCE_GAMES_PAGE'
      }
    },
    scope: (path) => {
      switch (path) {
        case 'teamPerformance':
          return SCOPE.TEAM.TEAM_PERFORMANCE;
        case 'playerPerformance':
          return SCOPE.TEAM.PLAYER_PERFORMANCE;
        default :
          return SCOPE.TEAM;
      }
    }
  },
  TEAMS: {
    PAGE: 'TEAMS_PAGE'
  },
  PROFILES: {
    PAGE: 'PROFILES_PAGE',
    scope: (path) => {
        switch (path) {
          case 'profiles':
            return SCOPE.PROFILES.PROFILE.PAGE;
          case 'intensities':
            return SCOPE.PROFILES.INTENSITIES.PAGE;
          case 'periods':
            return SCOPE.PROFILES.PERIODS_TYPE.PAGE;
          default :
            return SCOPE.PROFILES.PROFILE.PAGE;
        }
      },
  PROFILE:{
    PAGE: 'PROFILE'
  },
  INTENSITIES:{
    PAGE: 'INTENSITIES'
  },
  PERIODS_TYPE:{
    PAGE: 'PERIODS_TYPE'
  }
  },
  VIEW: {
    GAME: {
      scope: (path) => {
        switch (path) {
          case 'performance':
            return SCOPE.VIEW.GAME.PERFORMANCE;
          case 'ball':
            return SCOPE.VIEW.GAME.BALL_METRICS.PAGE;
          case 'report':
            return SCOPE.VIEW.GAME.REPORT.PAGE;
          case 'game_manage':
          return SCOPE.VIEW.GAME.GAME_MANAGE.PAGE;
          default :
            return SCOPE.VIEW.GAME;
        }
      },
      PERFORMANCE: {
        scope: (path) => {
          switch (path) {
            case 'condensed':
              return SCOPE.VIEW.GAME.PERFORMANCE.CONDENSED;
            case 'expanded':
              return SCOPE.VIEW.GAME.PERFORMANCE.EXPANDED;
            default :
              return null;
          }
        },
        CONDENSED: {
          scope: (path) => {
            switch (path) {
              case 'page':
                return SCOPE.VIEW.GAME.PERFORMANCE.CONDENSED.PAGE;
              case 'modal':
                return SCOPE.VIEW.GAME.PERFORMANCE.CONDENSED.MODAL;
              default :
                return null;
            }
          },
          PAGE: 'VIEW_GAME_PERFORMANCE_CONDENSED_PAGE',
          MODAL: 'VIEW_GAME_PERFORMANCE_CONDENSED_MODAL'
        },
        EXPANDED: {
          scope: (path) => {
            switch (path) {
              case 'page':
                return SCOPE.VIEW.GAME.PERFORMANCE.EXPANDED.PAGE;
              case 'modal':
                return SCOPE.VIEW.GAME.PERFORMANCE.EXPANDED.MODAL;
              default :
                return null;
            }
          },
          PAGE: 'VIEW_GAME_PERFORMANCE_EXPANDED_PAGE',
          MODAL: 'VIEW_GAME_PERFORMANCE_EXPANDED_MODAL'
        }
      },
      BALL_METRICS: {
        PAGE: 'VIEW_GAME_BALL_METRICS'
      },
      REPORT: {
        PAGE: 'VIEW_GAME_REPORT'
      },
      GAME_MANAGE:{
        PAGE: 'VIEW_GAME_MANAGE'
      }
    },
    PRACTICE: {
      scope: (path) => {
        switch (path) {
          case 'performance':
            return SCOPE.VIEW.PRACTICE.PERFORMANCE;
          case 'manage':
            return SCOPE.VIEW.PRACTICE.MANAGE.PAGE;
          case 'ball':
            return SCOPE.VIEW.PRACTICE.BALL;
          case 'report':
            return SCOPE.VIEW.PRACTICE.REPORT.PAGE;
          case 'combine':
            return SCOPE.VIEW.PRACTICE.COMBINE.PAGE;
          case 'event':
            return SCOPE.VIEW.PRACTICE.EVENT_LOGGER.PAGE;
          case 'map':
            return SCOPE.VIEW.PRACTICE.MAP.PAGE;
          case 'tracking':
            return SCOPE.VIEW.PRACTICE.TRACKING.PAGE;
          default :
            return SCOPE.VIEW.PRACTICE;
        }
      },
      BALL: {
        scope: (path) => {
          switch (path) {
            case 'flights':
              return SCOPE.VIEW.PRACTICE.BALL.METRICS.PAGE;
            default :
              return null;
          }
        },
        METRICS: {
          PAGE: 'VIEW_PRACTICE_BALL_METRICS'
        }
      },
      MANAGE: {
        PAGE: 'VIEW_PRACTICE_MANAGE'
      },
      TRACKING: {
        PAGE: 'VIEW_PRACTICE_TRACKING'
      },
      PERFORMANCE: {
        scope: (path) => {
          switch (path) {
            case 'condensed':
              return SCOPE.VIEW.PRACTICE.PERFORMANCE.CONDENSED;
            case 'expanded':
              return SCOPE.VIEW.PRACTICE.PERFORMANCE.EXPANDED;
            case 'metrics':
              return SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS;
            default :
              return null;
          }
        },
        CONDENSED: {
          scope: (path) => {
            switch (path) {
              case 'page':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.CONDENSED.PAGE;
              case 'modal':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.CONDENSED.MODAL;
              default:
                return null;
            }
          },
          PAGE: 'VIEW_PRACTICE_PERFORMANCE_CONDENSED_PAGE',
          MODAL: 'VIEW_PRACTICE_PERFORMANCE_CONDENSED_MODAL'
        },
        EXPANDED: {
          scope: (path) => {
            switch (path) {
              case 'page':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.EXPANDED.PAGE;
              case 'modal':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.EXPANDED.MODAL;
              default:
                return null;
            }
          },
          PAGE: 'VIEW_PRACTICE_PERFORMANCE_EXPANDED_PAGE',
          MODAL: 'VIEW_PRACTICE_PERFORMANCE_EXPANDED_MODAL'
        },
        METRICS: {
          scope: path => {
            switch (path) {
              case 'byPeriod':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE;
              case 'modal':
                return SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.MODAL;
              default:
                return null;
            }
          },
          PAGE: 'VIEW_PRACTICE_PERFORMANCE_METRICS_PAGE',
          MODAL: 'VIEW_PRACTICE_PERFORMANCE_METRICS_MODAL'
        },
        PAGE: 'VIEW_PRACTICE_PERFORMANCE',
        POP_UP: {
          PAGE: 'VIEW_PRACTICE_PERFORMANCE_POP_UP'
        }
      },
      REPORT: {
        PAGE: 'VIEW_PRACTICE_REPORT'
      },
      COMBINE:{
        PAGE: 'VIEW_COMBINE_LOGGER'
      },
      EVENT_LOGGER:{
        PAGE: 'VIEW_EVENT_LOGGER'
      },
      MAP: {
        PAGE: 'VIEW_PRACTICE_MAP'
      }
    },
    scope: (path) => {
      switch (path) {
        case 'game':
          return SCOPE.VIEW.GAME;
        case 'practice':
          return SCOPE.VIEW.PRACTICE;
        default :
          return null;
      }
    }
  },
  MONITOR: {
    PAGE: 'MONITOR_PAGE'
  },
  HEALTH: {
    PAGE: 'HEALTH_PAGE'
  },
  STATUS: {
    PAGE: 'PROCESSING_STATUS'
  },
  ACCOUNT: {
    PAGE: 'ACCOUNT_PAGE'
  },
  DATAOPS: {
    PAGE: 'DATAOPS_PAGE',
    ENTITIES: 'DATAOPS_MODAL_ENTITIES_EDIT',
    ROUTES: {
      PAGE: () => `/${SCOPE.DATAOPS.PARAMS.ROOT}/${SCOPE.DATAOPS.PARAMS.PAGE}`,
      ENTITIES: (gameId) => `/${SCOPE.DATAOPS.PARAMS.ROOT}/${SCOPE.DATAOPS.PARAMS.ENTITIES}/${gameId}`
    },
    PARAMS: {
      ROOT: 'dataops',
      PAGE: 'page',
      ENTITIES: 'entities'
    },
    scope: (path) => {
      switch (path) {
        case SCOPE.DATAOPS.PARAMS.PAGE:
          return SCOPE.DATAOPS.PAGE;
        case SCOPE.DATAOPS.PARAMS.ENTITIES:
          return SCOPE.DATAOPS.ENTITIES;
        default :
          return null;
      }
    }
  },
  CUSTOMERS: {
    PAGE: 'CUSTOMERS_PAGE',
    scope: (path) => {
      switch (path) {
        case 'users':
          return SCOPE.CUSTOMERS.USERS.PAGE;
        case 'players':
          return SCOPE.CUSTOMERS.PLAYERS.PAGE;
        case 'areas':
          return SCOPE.CUSTOMERS.AREAS.PAGE;
        case 'alerting':
          return  SCOPE.CUSTOMERS.ALERTING.PAGE;
        default:
          return SCOPE.CUSTOMERS;
      }
    },
     USERS: {
      PAGE: 'CUSTOMERS_USERS'
    },
    PLAYERS: {
      PAGE: 'CUSTOMERS_PLAYERS'
    },
    AREAS: {
      PAGE: 'CUSTOMERS_AREAS'
    },
    ALERTING: {
      PAGE: 'CUSTOMERS_ALERTING'
    }
  },
  scope: (path) => {
    switch (path) {
      case 'login': // without this the page crashed sometimes
        return SCOPE.LOGIN.PAGE;
      case 'schedule' :
        return SCOPE.SCHEDULE;
      case 'practices' :
        return SCOPE.PRACTICES.PAGE;
      case 'players' :
        return SCOPE.PLAYERS.PAGE;
      case 'player' :
        return SCOPE.PLAYER;
      case 'games' :
        return SCOPE.GAMES.PAGE;
      case 'team' :
        return SCOPE.TEAM;
      case 'teams' :
        return SCOPE.TEAMS.PAGE;
      case 'profiles' :
        return SCOPE.PROFILES.PAGE;
      case 'account' :
        return SCOPE.ACCOUNT.PAGE;
      case 'view' :
        return SCOPE.VIEW;
      case 'entities' :
        return SCOPE.ENTITIES;
      case 'monitor' :
        return SCOPE.MONITOR.PAGE;
      case 'health' :
        return SCOPE.HEALTH.PAGE;
      case 'dataops' :
        return SCOPE.DATAOPS;
      case 'customers' :
        return SCOPE.CUSTOMERS;
      case 'status' :
        return SCOPE.STATUS.PAGE;
      default :
        return null;
    }
  }
};

export const FORMAT_DATE_ROUTE = 'yyyy/M/d';

export const EMPTY_ARRAY = [];
// export const CONTROLLERS = [];
// export const PRACTICES_PAGE_CONTROLLERS = [];
// export const MANAGE_TAB_CONTROLLERS = [];
export const CONTROLLER_SET = new Set();
export const METRICS_CONTROLLER_SET = new Set();

export const ROLES = {
  COMMAND_CENTER: 'CommandCenter'

};

export const PAGE_SELECTOR = (tab, subTab, type) => {
  switch (tab) {
    case 'performance':
      if (subTab === 'condensed') {
        if (type === 'game') {
          return 'Key Metrics';
        }
        return 'Live Metrics';
      }
      return 'All Metrics';
    case 'ball':
      return 'Ball Metrics';
    case 'report':
      return 'Reporting';
    case 'manage':
      return 'Practice Manager';
    case 'game_manage':
      return 'Practice Manager';
    default:
      break;
  }
};

export const ENTITY_TYPES = [
  { label: 'Player', value: 'player' },
  { label: 'Ball', value: 'ball' },
  { label: 'Official', value: 'official' },
  { label: 'Object', value: 'object' }
];

export const ENTITY_MODELS = (type) => {
  switch (type) {
    case 'player':
      return [
        { label: 'Player', value: 'player' }
      ];
    case 'ball':
    case 'gameBall':
    case 'kickBall':
      return [
        { label: 'Game Ball', value: 'gameBall' },
        { label: 'Kick Ball', value: 'kickBall' }
      ];
    case 'official':
      return [
        { label: 'Official', value: 'official' }
      ];
    case 'object':
      return [
        { label: 'Pylon', value: 'pylon' },
        { label: 'StartOfDrive Marker', value: 'startOfDriveMarker' },
        { label: 'FirstDown Marker', value: 'firstDownMarker' },
        { label: 'DownBox Marker', value: 'downBoxMarker' },
        { label: 'OfficialFlag', value: 'officialFlag' },
        { label: 'BeanBag', value: 'beanBag' },
        { label: 'Cone', value: 'cone' }
      ];
    default:
      return [];
  }
};

export const ENTITY_GROUPS = (teamId) => [
  `${teamId}`, `site-${teamId}`, `official`
];

export const ENTITY_OFFSETS = [
  '-0.5,0,0', '0,0,0', '0.5,0,0'
];

export const DEFAULT_INTENSITIES = new Set([
    'Low' ,
    'Medium' ,
    'High' ,
    'Walk-Through' ,
    'Workout' ,
    'Pre-Practice' ,
    'Rehab' ,
    'KO-6' ,
    'KO-5' ,
    'KO-4' ,
    'KO-3' ,
    'KO-2' ,
    'KO-1' ,
    'Padded' ,
    'Shells' ,
    'GD-6' ,
    'GD-5' ,
    'GD-4' ,
    'GD-3' ,
    'GD-2' ,
    'GD-1'
]);

export const ENTITY_STATUS_FILTER = {
  default: 'No Filter',
  types: ['ACT', 'DEV', 'RES', 'PUP', 'RSN', 'UF', 'EXE', 'NWT', 'CUT', 'No Filter']
};

export const USER_ROLES_FILTER = {
  default: 'All',
  types: ['All', 'Admin', 'User', 'Other']
};

// Mirrors backend 10* users group
export const SENIOR_BOWL_COMBINE_DATASET_KEYS = [
  '1000', '1001', '1002', '1003', '1004', '1005',
  '1006', '1007', '1008', '1009', '1010', '1011',
  '7600', '7677', '7700', '9600', '9700'
];

export const ENTITY_STATUS_TYPES = {
  ACT: 'ACT',
  DEV: 'DEV',
  RES: 'RES',
  PUP: 'PUP',
  RSN: 'RSN',
  UF: 'UF',
  EXE: 'EXE',
  NWT: 'NWT',
  CUT: 'CUT'
};

export const ENTITY_MODEL_FILTER = {
  default: 'No Filter',
  types: ['player', 'gameBall', 'kickBall', 'No Filter']
};

export const ENTITY_MODEL_TYPES = {
  PLAYER: 'player',
  GAME_BALL: 'gameBall',
  KICK_BALL: 'kickBall',
};

export const ENTITY_VALUES = {
  PLAYER: 'player',
  BALL: 'ball',
  OFFICIAL: 'official',
  OBJECT: 'object'
};

/*export const ENTITY_FILTER_MODELS = {
  default: 'No filter',
  types: ['ES+NFL', 'NFL Feed Only', 'ES Feed Only', 'gameBall', 'No Filter']
};*/

export const PRACTICE_PERIODS = {
  name: 'Practice Periods',
  types: [
    // New Selection Types
    'NFL - Pre/Post Practice',
    'NFL - Stretch',
    'NFL - Walk/Jog Through',
    'NFL - Special Teams',
    'NFL - Individual',
    'NFL - 1on1',
    'NFL - 7on7',
    'NFL - 9on7',
    'NFL - 9on9',
    'NFL - Other Partial Team',
    'NFL - 11on11 Run Specific',
    'NFL - 11on11 Pass Specific',
    'NFL - 11on11 Mixed',
    'NFL - Conditioning',
    'NFL - Rehab/RTP',
    'NFL - Break',
    // old types
    'Pre-Practice',
    'Stretch',
    'Warm-up/Stretch',
    'Walk-Thru',
    'Break',
    'Group',
    'Individual',
    'Position',
    'Situation',
    'Special-Teams',
    'Team',
    'Conditioning',
    'Post-Practice',
    'Telemetry'
  ],
  title: 'PRACTICE PERIODS'
};
export const DEFAULT_PERIOD_TYPES = new Set(PRACTICE_PERIODS.types);

export const REFRESH_INTERVALS = {
  MANAGE: 15000
};

export const DATAOPS_PROGRESS = (status) => {
  switch (status) {
    case 'I_I':
      return [colors.started, colors.unstarted, colors.unstarted, colors.unstarted];
    case 'I_C':
      return [colors.finished, colors.unstarted, colors.unstarted, colors.unstarted];
    case 'R_I':
      return [colors.finished, colors.started, colors.unstarted, colors.unstarted];
    case 'R_C':
      return [colors.finished, colors.finished, colors.unstarted, colors.unstarted];
    case 'B_I':
      return [colors.finished, colors.finished, colors.started, colors.unstarted];
    case 'B_C':
      return [colors.finished, colors.finished, colors.finished, colors.unstarted];
    case 'F_I':
      return [colors.finished, colors.finished, colors.finished, colors.started];
    case 'F_C':
      return [colors.finished, colors.finished, colors.finished, colors.finished];
    default:
      return [colors.unstarted, colors.unstarted, colors.unstarted, colors.unstarted];
  }
};

export const DATAOPS_ACTIONS = (status) => {
  switch (status) {
    case 'I_I':
      return [colors.started, colors.gray, colors.gray, colors.gray];
    case 'I_C':
      return [colors.finished, colors.gray, colors.gray, colors.gray];
    case 'R_I':
      return [colors.finished, colors.started, colors.gray, colors.gray];
    case 'R_C':
      return [colors.finished, colors.finished, colors.gray, colors.gray];
    case 'B_I':
      return [colors.finished, colors.finished, colors.started, colors.gray];
    case 'B_C':
      return [colors.finished, colors.finished, colors.finished, colors.gray];
    case 'F_I':
      return [colors.finished, colors.finished, colors.finished, colors.started];
    case 'F_C':
      return [colors.finished, colors.finished, colors.finished, colors.finished];
    default:
      return [colors.gray, colors.gray, colors.gray, colors.gray];
  }
};

export const DATAOPS_ACTIONS_FILTER = {

  default: 'No Filter',
  types: [
    {
      label: 'Launching Instance',
      value: 'I_I'
    },
    {
      label: 'Launching Complete',
      value: 'I_C'
    },
    {
      label: 'Retrack Initiated',
      value: 'R_I'
    },
    {
      label: 'Retrack Complete',
      value: 'R_C'
    },
    {
      label: 'Ball Retrack Initiated',
      value: 'B_I'
    },
    {
      label: 'Ball Retrack Complete',
      value: 'B_C'
    },
    {
      label: 'Finalize Initiated',
      value: 'F_I'
    },
    {
      label: 'Finalize Complete',
      value: 'F_C'
    },
    {
      label: 'No Filter',
      value: 'No Filter'
    }
  ]

};
export const HEADER_NAMES = {
  'PLAYER': 'Player Display Name',
  'EX.': 'Exclude Player From Avg. Summary',
  'NO.': 'Player Number',
  'POS.': 'Position',

  'TARGET SPEED': 'Target Speed',
  'MAX SPEED': 'Max Speed',
  'MAX SUST. SPEED': 'Max Sustained Speed',
  'TIME SINCE X% OF MAX': 'Time since X% of Max',

  'TOTAL DIST.': 'Total Distance',
  'HARD EFF. DIST.': 'Hard Effort Distance',
  'WALK': 'Walk',
  'JOG': 'Jog',
  'RUN': 'Run',
  'SPRINT': 'Sprint',
  'MAX SPRINT': 'Max Sprint',

  'LOW': 'Low',
  'MED.': 'Medium',
  'HIHG': 'High',

  'TOTAL DIST': 'Total Distance',
  'TEAM TARGET MPH': 'Team Target MPH',
  'TEAM WALK YDS': 'Team Walk Yards',
  'TEAM JOG YDS': 'Team Jog Yards',
  'TEAM RUN YDS': 'Team Run Yards',
  'TEAM SPRINT YDS': 'Team Sprint Yards',
  'TEAM MAX SPRINT YDS': 'Team Max Sprint Yards',
  'YDS 10+': 'Yards at 10+ MPH',
  'YDS 12+': 'Yards at 12+ MPH',
  'TEAM WALK TIME': 'Team Walk Time',
  'TEAM SPRINT TIME': 'Team Sprint Time',
  'TEAM MAX SPRINT TIME': 'Team Max Sprint Time',
  'TIME 10+': 'Time at 10+ MPH',
  'TIME 12+': 'Time at 12+ MPH',
  'TEAM HARD EFFOR DIST': 'Team Hard Effort Distance',
  'TEAM SPRINT COUNT': 'Team Sprint Count',
  'TEAM MAX SPRINT COUNT': 'Team Max Sprint Count',


  'REL TARGET MPH': 'Relative Target MPH',
  'REL WALK YDS': 'Relative Walk Yds',
  'REL JOG YDS': 'Relative Jog Yards',
  'REL RUN YDS': 'Relative Run Yards',
  'REL SPRINT YDS': 'Relative Sprint Yards',
  'REL MAX SPRINT YDS': 'Relative Max Sprint Yards',
  'REL WALK TIME': 'Relative Walk Time',
  'REL JOG TIME': 'Relative Jog Time',
  'REL RUN TIME': 'Relative Run Time',
  'REL SPRINT TIME': 'Relative Sprint Time',
  'REL MAX SPRINT TIME': 'Relative Max Sprint Time',
  'REL HARD EFFOR DIST': 'Relative Hard Effort Distance',
  'REL SPRINT COUNT': 'Relative Sprint Count',
  'REL MAX SPRINT COUNT': 'Relative Max Sprint Count',


  'YDS/MIN': 'Yards/Minute',
  'ACT AVG YPS': 'Average Active Speed (YPS)',
  'ACT AVG MPH': 'Average Active Speed (MPH)',
  'ACCEL/MIN': 'Accelerations/Minute',
  'DECEL/MIN': 'Decelerations/Minute',
  'MAX YPS': 'Max Speed (YPS)',
  'MAX MPH': 'Max Speed (MPH)',
  'EXPLOSIVE EFFORT': 'Explosive Effort',
  'MAX STND YPS': 'Max Sustained Speed (YPS)',
  'MAX STND MPH': 'Max Sustained Speed (MPH)',
  'PERFORMANCE TIME': 'Performance Time',

  'TOTAL ACCELS': 'Total Accelerations',
  'ACCEL LOW': 'Low Acceleration Count',
  'ACCEL MED': 'Medium Acceleration Count',
  'ACCEL HIGH': 'High Acceleration Count',
  'ACL DIST LOW': 'Distance in Low Acceleration',
  'ACL DIST MED': 'Distance in Medium Acceleration',
  'ACL DIST HIGH': 'Distance in High Acceleration',
  'TOTAL DECELS': 'Total Deceleration Counts',
  'DECELS LOW': 'Low Deceleration Counts',
  'DECELS MED': 'Medium Deceleration Counts',
  'DECELS HIGH': 'High Deceleration Counts',
  'Decel DIST LOW': 'Distance in Low Deceleration',
  'Decel DIST MED': 'Distance in Medium Deceleration',
  'Decel DIST HIGH': 'Distance in High Deceleration',
  'ACL WALK COUNT': 'Accel Walk Count',
  'ACL JOG COUNT': 'Accel Jog Count',
  'ACL RUN COUNT': 'Accel Run Count',
  'ACL SPRINT COUNT': 'Accel Sprint Count',
  'ACL MAX SPRINT COUNT': 'Accel Max Sprint Count',
  'DCL WALK COUNT': 'Decel Walk Count',
  'DCL JOG COUNT': 'Decel Jog Count',
  'DCL RUN COUNT': 'Decel Run Count',
  'DCL SPRINT COUNT': 'Decel Sprint Count',
  'DCL MAX SPRINT COUNT': 'Decel Max Sprint Count',
  'MAX ACCEL': 'Max Acceleration',
  'MAX STND ACCEL': 'Max Sustained Acceleration',

  'MAX DECEL': 'Max Deceleration',
  'MAX STND DECEL': 'Max Sustained Deceleration',
  'COD MED': 'Changes of Direction at Medium Speed',
  'COD HIGH': 'Changes of Direction at High Speed',
  'COD TOTAL': 'Total Changes of Direction',
  'EXERTION INDEX': 'Exertion Index',
  // NEW ACCLES AND DECELS
  //ACCELS
  'ACCELS AT 20% MAX SPD': 'Acceleration at 20% of Max Speed',
  'ACCELS AT 30% MAX SPD': 'Acceleration at 30% of Max Speed',
  'ACCELS AT 40% MAX SPD': 'Acceleration at 40% of Max Speed',
  'ACCELS AT 50% MAX SPD': 'Acceleration at 50% of Max Speed',
  'ACCELS AT 60% MAX SPD': 'Acceleration at 60% of Max Speed',
  'ACCELS AT 60%+ MAX SPD': 'Acceleration at 60% plus of Max Speed',
  // DECELS
  'DECELS AT 20% MAX SPD': 'Deceleration at 20% of Max Speed',
  'DECELS AT 30% MAX SPD': 'Deceleration at 30% of Max Speed',
  'DECELS AT 40% MAX SPD': 'Deceleration at 40% of Max Speed',
  'DECELS AT 50% MAX SPD': 'Deceleration at 50% of Max Speed',
  'DECELS AT 60% MAX SPD': 'Deceleration at 60% of Max Speed',
  'DECELS AT 60%+ MAX SPD': 'Deceleration at 60% plus of Max Speed',

  'NAME': 'Name',
  'DATE/TIME': 'Date/Time',
  'INTENSITY.': 'Intensity.',
  'AVG. MAX SPEED': 'Average Max Speed',
  'AVG. MAX SUST. SPEED': 'Average Max Sustained Speed',
  'AVG. TTL. DIST.': 'Average Total Distance',
  'AVG. ACCEL CT.': 'Average Acceleration Ct.',
  'AVG. DECEL CT.': 'Average Deceleration Ct.',

  'FLIGHT TYPE': 'Flight Type',
  'INITIAL AIR SPEED (MPH)': 'Initial air Speed (MPH)',
  'INITIAL ROTATION (RPM)': 'Initial Rotation (RPM)',
  'START TIME': 'Start Time',
  'FLIGHT DURATION(S)': 'Flight Duration (S)',
  'PEAK HEIGHT (FT)': 'Peak Height (FT)',
  'GROUND DISTANCE (YDS)': 'Ground Distance (YDS)',

  'DURATION': 'Duration',
  'INTENSITY': 'Intensity',
  '# OF PERIODS': 'Number of Periods',
  'TIME TRACKED': 'Time Tracked',
  'TIME MOVING': 'Time Moving',

  // LATERAL LOAD METRICS
  'CUMULATIVE LOAD': 'Cumulative Load',
  'LOAD BIAS': 'Load Bias',
  'LEFT LOW LATERAL LOAD': 'Left Low Lateral Load Count',
  'LEFT MEDIUM LATERAL LOAD' : 'Left Medium Lateral Load Count',
  'LEFT HIGH LATERAL LOAD': 'Left High Lateral Load Count',
  'RIGHT LOW LATERAL LOAD': 'Right Low Lateral Load Count',
  'RIGHT MEDIUM LATERAL LOAD' :'Right Medium Lateral Load Count',
  'RIGHT HIGH LATERAL LOAD': 'Right High Lateral Load Count'
  
};

export const RELATIVE_METRICS = {
  //SPEED
  'targetMPH': 'targetMPHRelative', // TARGET SPEED
  'lastTimeVelocityTargetHitTs': 'lastTimeVelocityTargetHitTsRelative', // TIME SINCE X% OF MAX
  // DISTANCES
  'hardEffortDist': 'hardEffortDistRelative', // HARD EFF. DIST.
  'walkYds': 'walkYdsRelative', // WALK
  'jogYds': 'jogYdsRelative', // JOG
  'runYds': 'runYdsRelative', // RUN
  'sprintYds': 'sprintYdsRelative', //SPRINT
  'maxSprintYds': 'maxSprintYdsRelative', // MAX SPRINT
  // PERCENTAGES
  'historyHardEffortDistance_%': 'historyHardEffortDistanceRelative_%',
  'historyTeamHEDMovedAtSec': 'historyRelHEDMovedAtSec',
  'walkYds_%': 'walkYdsRelative_%', // WALK
  'jogYds_%': 'jogYdsRelative_%', // JOG
  'runYds_%': 'runYdsRelative_%', // RUN
  'sprintYds_%': 'sprintYdsRelative_%', //SPRINT
  'maxSprintYds_%': 'maxSprintYdsRelative_%', // MAX SPRINT
  // COUNTS
  'walkCount': 'walkCountRelative',
  'jogCount': 'jogCountRelative',
  'runCount': 'runCountRelative',
  'sprintCount': 'sprintCountRelative',
  'maxSprintCount': 'maxSprintCountRelative',
  // COUNTS PERCENTAGES
  'walkCount_%': 'walkCountRelative_%',
  'jogCount_%': 'jogCountRelative_%',
  'runCount_%': 'runCountRelative_%',
  'sprintCount_%': 'sprintCountRelative_%',
  'maxSprintCount_%': 'maxSprintCountRelative_%',
  // LATERA LOAD METRICS
  'leftHighLatLoadCount': 'leftHighLatLoadCount',
  'leftMedLatLoadCount': 'leftMedLatLoadCount',
  'leftLowLatLoadCount': 'leftLowLatLoadCount',
  'rightHighLatLoadCount': 'rightHighLatLoadCount',
  'rightMedLatLoadCount': 'rightMedLatLoadCount',
  'rightLowLatLoadCount': 'rightLowLatLoadCount',

};
//LIVE ZONES METRICS
export const CUSTOM_ZONE_METRICS = {
  //SPEED
  'targetMPH': 'targetMPHCustom',
  'maxSpeedMPH' : 'maxSpeedMPH',
  'maxSustainedSpeedMPH':'maxSustainedSpeedMPH',
  'lastTimeVelocityTargetHitTs': 'lastTimeVelocityTargetHitTsCustom',
  // DISTANCES
  'hardEffortDist': 'hardEffortDistCustom', // HARD EFF. DIST.
  'walkYds': 'walkYdsCustom', // WALK
  'jogYds': 'jogYdsCustom', // JOG
  'runYds': 'runYdsCustom', // RUN
  'sprintYds': 'sprintYdsCustom', //SPRINT
  'maxSprintYds': 'maxSprintYdsCustom', // MAX SPRINT
  // DISTANCES PERCENTAGE
  'historyHardEffortDistance_%': 'historyHardEffortDistanceCustom_%',
  'walkYds_%': 'walkYdsCustom_%', // WALK
  'jogYds_%': 'jogYdsCustom_%', // JOG
  'runYds_%': 'runYdsCustom_%', // RUN
  'sprintYds_%': 'sprintYdsCustom_%', //SPRINT
  'maxSprintYds_%': 'maxSprintYdsCustom_%', // MAX SPRINT
  // COUNTS
  'walkCount': 'walkCountCustom',
  'jogCount': 'jogCountCustom',
  'runCount': 'runCountCustom',
  'sprintCount': 'sprintCountCustom',
  'maxSprintCount': 'maxSprintCountCustom',
   // COUNTS PERCENTAGES
   'walkCount_%': 'walkCountCustom_%',
   'jogCount_%': 'jogCountCustom_%',
   'runCount_%': 'runCountCustom_%',
   'sprintCount_%': 'sprintCountCustom_%',
   'maxSprintCount_%': 'maxSprintCountCustom_%',
};

export const METRICS_KEYS = [
  // SPEED
  ['targetMPH', 'targetMPHRelative'], ['maxSpeedMPH', 'maxSpeedMPH'], ['maxSustainedSpeedMPH', 'maxSustainedSpeedMPH'], // TIME SINCE X% OF MAX
  ['maxSpeedYPS', 'maxSpeedYPS'], ['maxSustainedSpeedYPS', 'maxSustainedSpeedYPS'],
  ['ypm', 'ypm'],
  ['maxSpeedMPHAs%ofTarget', 'maxSpeedMPHAs%ofTarget'], ['maxSustSpeedMPHAs%ofTarget', 'maxSustSpeedMPHAs%ofTarget'],
  ['TIME SINCE X% OF MAX', 'TIME SINCE X% OF MAX'], // fake
  // DISTANCES
  ['totalDis', 'totalDis'], ['hardEffortDist', 'hardEffortDistRelative'],
  ['historyTotalDistance_%', 'historyTotalDistance_%'], ['historyHardEffortDistance_%', 'historyHardEffortDistanceRelative_%'],
  ['historyHardEffortDistanceRelative_%', 'historyHardEffortDistanceRelative_%'], ['historyHardEffortDistanceCustom_%', 'historyHardEffortDistanceCustom_%'],
  ['walkYds_%', 'walkYds_%'], ['walkYds', 'walkYdsRelative'], ['walkYdsCustom_%', 'walkYdsCustom_%'], ['walkCountCustom_%', 'walkCountCustom_%'], ['walkYdsRelative_%', 'walkYdsRelative_%'],
  ['jogYds', 'jogYdsRelative'], ['jogYds_%', 'jogYds_%'], ['jogYdsRelative_%', 'jogYdsRelative_%'], ['jogYdsCustom_%', 'jogYdsCustom_%'], ['jogCountCustom_%', 'jogCountCustom_%'],
  ['runYds', 'runYdsRelative'],  ['runYds_%', 'runYds_%'], ['runYdsRelative_%', 'runYdsRelative_%'], ['runYdsCustom_%', 'runYdsCustom_%'], ['runCountCustom_%', 'runCountCustom_%'],
  ['sprintYds_%', 'sprintYds_%'], ['sprintYdsRelative_%', 'sprintYdsRelative_%'], ['sprintYdsCustom_%', 'sprintYdsCustom_%'], ['sprintCountCustom_%', 'sprintCountCustom_%'],
  ['sprintYds', 'sprintYdsRelative'], ['maxSprintYds', 'maxSprintYdsRelative'], ['maxSprintYds_%', 'maxSprintYds_%'], ['maxSprintYdsRelative_%', 'maxSprintYdsRelative_%'], ['maxSprintYdsCustom_%', 'maxSprintYdsCustom_%'], ['maxSprintCountCustom_%', 'maxSprintCountCustom_%'],
  // ACCEL COUNTS
  ['accelSlow', 'accelSlow'], ['accelMed', 'accelMed'], ['accelFast', 'accelFast'],
  // DECEL COUNTS
  ['deccelSlow', 'deccelSlow'], ['deccelMed', 'deccelMed'], ['deccelFast', 'deccelFast'],
  // NEW ACCELS
  ['accCnt20pOfMax', 'accCnt20pOfMax'], ['accCnt30pOfMax', 'accCnt30pOfMax'], ['accCnt40pOfMax', 'accCnt40pOfMax'], ['accCnt50pOfMax', 'accCnt50pOfMax'], ['accCnt60pOfMax', 'accCnt60pOfMax'], ['accCnt60plusOfMax','accCnt60plusOfMax'],
  // NEW DECELS
  ['decCnt20pOfMax', 'decCnt20pOfMax'], ['decCnt30pOfMax', 'decCnt30pOfMax'], ['decCnt40pOfMax', 'decCnt40pOfMax'], ['decCnt50pOfMax', 'decCnt50pOfMax'], ['decCnt60pOfMax', 'decCnt60pOfMax'], ['decCnt60plusOfMax', 'decCnt60plusOfMax'],
   // Expandend
  ['explosiveEffort', 'explosiveEffort'],
  ['targetMPHRelative', 'targetMPHRelative'],
  ['runTime', 'runTimeRelative'],
  ['dist10Plus', 'dist10Plus'], ['walkTime', 'walkTimeRelative'], ['sprintTime', 'sprintTimeRelative'], ['maxSprintTime', 'maxSprintTimeRelative'],
  ['time10Plus', 'time10Plus'],
  ['walkCount', 'walkCountRelative'], 
  ['walkCount_%', 'walkCount_%'], ['walkCountRelative_%', 'walkCountRelative_%'],
  ['jogCount', 'jogCountRelative'],
  ['jogCount_%', 'jogCount_%'], ['jogCountRelative_%', 'jogCountRelative_%'],
  ['runCount', 'runCountRelative'],
  ['runCount_%', 'runCount_%'], ['runCountRelative_%', 'runCountRelative_%'],
  ['sprintCount', 'sprintCountRelative'],
  ['sprintCount_%', 'sprintCount_%'], ['sprintCountRelative_%', 'sprintCountRelative_%'],
  ['maxSprintCount', 'maxSprintCountRelative'],
  ['maxSprintCount_%', 'maxSprintCount_%'], ['maxSprintCountRelative_%', 'maxSprintCountRelative_%'],
  ['walkTimeRelative', 'walkTimeRelative'],
  ['hardEffortDistRelative', 'hardEffortDistRelative'],
  ['walkCountRelative', 'walkCountRelative'],
  ['jogCountRelative', 'jogCountRelative'],
  ['runCountRelative', 'runCountRelative'],
  ['sprintCountRelative', 'sprintCountRelative'],
  ['maxSprintCountRelative', 'maxSprintCountRelative'],
  ['walkYdsRelative', 'walkYdsRelative'], ['jogYdsRelative', 'jogYdsRelative'], ['runYdsRelative', 'runYdsRelative'],
  ['maxSprintYdsRelative', 'maxSprintYdsRelative'],
  ['jogTime', 'jogTimeRelative'],
  ['actYPS', 'actYPSRel'], ['actMPH', 'actMPHRel'],
  ['actYPSRel', 'actYPSRel'], ['actMPHRel', 'actMPHRel'],
  ['sprintYdsRelative', 'sprintYdsRelative'],
  ['jogTimeRelative', 'jogTimeRelative'],
  ['runTimeRelative', 'runTimeRelative'],
  ['sprintTimeRelative', 'sprintTimeRelative'], ['maxSprintTimeRelative', 'maxSprintTimeRelative'],
  ['accelDistSlow', 'accelDistSlow'], ['accelDistMed', 'accelDistMed'], ['accelDistFast', 'accelDistFast'],
  ['deccelDistSlow', 'deccelDistSlow'], ['deccelDistMed', 'deccelDistMed'], ['deccelDistFast', 'deccelDistFast'],
  ['accWalkCnt', 'accWalkCnt'],
  ['accJogCnt', 'accJogCnt'],
  ['accRunCnt', 'accRunCnt'],
  ['accSprintCnt', 'accSprintCnt'],
  ['accMaxSprintCnt', 'accMaxSprintCnt'],
  ['decWalkCnt', 'decWalkCnt'],
  ['decJogCnt', 'decJogCnt'],
  ['decRunCnt', 'decRunCnt'],
  ['decSprintCnt', 'decSprintCnt'],
  ['decMaxSprintCnt', 'decMaxSprintCnt'],
  ['maxAccel', 'maxAccel'],
  ['maxDecel', 'maxDecel'],
  ['maxSustAccel', 'maxSustAccel'],
  ['maxSustDecel', 'maxSustDecel'],
  ['maxSprintYdsRelative', 'maxSprintYdsRelative'],
  //Lateral Load
  ['leftHighLatLoadCount', 'leftHighLatLoadCount'],
  ['leftMedLatLoadCount', 'leftMedLatLoadCount'],
  ['leftLowLatLoadCount', 'leftLowLatLoadCount'],
  ['rightHighLatLoadCount', 'rightHighLatLoadCount'],
  ['rightMedLatLoadCount', 'rightMedLatLoadCount'],
  ['rightLowLatLoadCount', 'rightLowLatLoadCount'],
  ['cumulativeBalanceLoad', 'cumulativeBalanceLoad'],
  ['biasedBalanceLoad', 'biasedBalanceLoad'],

  // extra
  ['targetYPM', 'targetYPMRelative'],
  //
  ['accelPerMin', 'accelPerMin'], ['deccelPerMin', 'deccelPerMin'],
  ['exIndex', 'exIndex'],
  ['timeMoving', 'timeMoving'],
  ['timeTrkd', 'timeTrkd'],
  // modal player extra
  ['time10plus', 'time10plus'],
  // maxSpeedMPHAsPercentageOfTarget
  ['maxSpeedMPHAs%ofTarget_Relative', 'maxSpeedMPHAs%ofTarget_Relative'], ['maxSpeedMPHAs%ofTarget', 'maxSpeedMPHAs%ofTarget'], ['maxSpeedMPHAs%ofTarget_Custom', 'maxSpeedMPHAs%ofTarget_Custom'],
  // maxSustSpeedMPHAsPercentageOfTarget
  ['maxSustSpeedMPHAs%ofTarget_Relative', 'maxSustSpeedMPHAs%ofTarget_Relative'], ['maxSustSpeedMPHAs%ofTarget', 'maxSustSpeedMPHAs%ofTarget'],
  // maxSpeedYPMAsPercentageOfTarget
  ['maxSpeedYPMAs%ofTarget_Relative', 'maxSpeedYPMAs%ofTarget_Relative'], ['maxSpeedYPMAs%ofTarget', 'maxSpeedYPMAs%ofTarget'],
  // maxSustSpeedYPMAsPercentageOfTarget
  ['maxSustSpeedYPMAs%ofTarget_Relative', 'maxSustSpeedYPMAs%ofTarget_Relative'], ['maxSustSpeedYPMAs%ofTarget'], ['maxSustSpeedMPHAs%ofTarget_Custom', 'maxSustSpeedMPHAs%ofTarget_Custom'],
  // monitorspeedpercentofmax
  ['lastTimeVelocityTargetHitTs', 'lastTimeVelocityTargetHitTsRelative'],
  ['lastTimeVelocityTargetHitTsRelative', 'lastTimeVelocityTargetHitTsRelative'],
  //Player load metric
  ['zLoad', 'zLoad'],
  // In Progress Comps
  ['historyDistMovedAtSec_%', 'historyDistMovedAtSec_%'],
  ['historyTeamHEDMovedAtSec_%', 'historyRelHEDMovedAtSec_%'],
  ['historyRelHEDMovedAtSec_%', 'historyRelHEDMovedAtSec_%'],
  //CUSTOM ZONES
  ['timeMoving', 'timeMoving'], ['totalDis', 'totalDis'], ['targetMPHCustom', 'targetMPHCustom'],
  ['walkYdsCustom', 'walkYdsCustom'], ['jogYdsCustom', 'jogYdsCustom'], ['runYdsCustom', 'runYdsCustom'],
  ['sprintYdsCustom', 'sprintYdsCustom'], ['maxSprintYdsCustom', 'maxSprintYdsCustom'],
  ['walkTimeCustom', 'walkTimeCustom'], ['jogTimeCustom', 'jogTimeCustom'], ['runTimeCustom', 'runTimeCustom'],
  ['sprintTimeCustom', 'sprintTimeCustom'], ['maxSprintTimeCustom', 'maxSprintTimeCustom'],
  ['hardEffortDistCustom', 'hardEffortDistCustom'], ['walkCountCustom', 'walkCountCustom'],
  ['jogCountCustom', 'jogCountCustom'], ['runCountCustom', 'runCountCustom'],
  ['sprintCountCustom', 'sprintCountCustom'],
  ['maxSprintCountCustom', 'maxSprintCountCustom']
  
];
// EXPANDED VIEW HEADERS
export const TEAM_ZONE_HEADERS = [
  'TIME MOVING',
  'TOTAL DIST',
  'TEAM TARGET MPH',
  'TEAM WALK YDS',
  'TEAM JOG YDS',
  'TEAM RUN YDS',
  'TEAM SPRINT YDS',
  'TEAM MAX SPRINT YDS',
  'YDS 10+',
  'TEAM WALK TIME',
  'TEAM JOG TIME',
  'TEAM RUN TIME',
  'TEAM SPRINT TIME',
  'TEAM MAX SPRINT TIME',
  'TIME 10+',
  'TEAM HARD EFFORT DIST',
  'TEAM WALK COUNT',
  'TEAM JOG COUNT',
  'TEAM RUN COUNT',
  'TEAM SPRINT COUNT',
  'TEAM MAX SPRINT COUNT'];

export const PLAYER_RELATIVE_HEADERS = [
  'TIME MOVING',
  'TOTAL DIST',
  'REL TARGET MPH',
  'REL WALK YDS',
  'REL JOG YDS',
  'REL RUN YDS',
  'REL SPRINT YDS',
  'REL MAX SPRINT YDS',
  'REL WALK TIME',
  'REL JOG TIME',
  'REL RUN TIME',
  'REL SPRINT TIME',
  'REL MAX SPRINT TIME',
  'REL HARD EFFORT DIST',
  'REL WALK COUNT',
  'REL JOG COUNT',
  'REL RUN COUNT',
  'REL SPRINT COUNT',
  'REL MAX SPRINT COUNT'];

export const CUSTOM_ZONE_HEADERS = [
  'TIME MOVING',
  'TOTAL DIST',
  'CUST TARGET MPH',
  'CUST WALK YDS',
  'CUST JOG YDS',
  'CUST RUN YDS',
  'CUST SPRINT YDS',
  'CUST MAX SPRINT YDS',
  'CUST WALK TIME',
  'CUST JOG TIME',
  'CUST RUN TIME',
  'CUST SPRINT TIME',
  'CUST MAX SPRINT TIME',
  'CUST HARD EFFORT YDS',
  'CUST WALK COUNT',
  'CUST JOG COUNT',
  'CUST RUN COUNT',
  'CUST SPRINT COUNT',
  'CUST MAX SPRINT COUNT',  
];
export const TIMING_PEACE_HEADERS = [
  'TIME TRACKED',
  'TIME MOVING',
  'YDS/MIN',
  'ACT AVG YPS',
  'ACT AVG MPH',
  'ACCEL/MIN',
  'DECEL/MIN',
  'MAX YPS',
  'MAX MPH',
  'EXPLOSIVE EFFORT',
  'MAX STND YPS',
  'MAX STND MPH'];

export const ACCELS_DECELS_HEADERS = [
    'TIME TRACKED',
    'TIME MOVING',
    'TOTAL ACCELS',
    'ACCEL LOW',
    'ACCEL MED',
    'ACCEL HIGH',
    'ACL DIST LOW',
    'ACL DIST MED',
    'ACL DIST HIGH',
    'TOTAL DECELS',
    'DECELS LOW',
    'DECELS MED',
    'DECELS HIGH',
    'Decel DIST LOW',
    'Decel DIST MED',
    'Decel DIST HIGH',
    'EXERTION INDEX',
    'PLAYER LOAD',
    'MAX ACCEL',
    'MAX STND ACCEL',
    'MAX DECEL',
    'MAX STND DECEL'];

export const ACCELS_AT_HEADERS = [
  'ACCELS AT 20% MAX SPD',
  'ACCELS AT 30% MAX SPD',
  'ACCELS AT 40% MAX SPD',
  'ACCELS AT 50% MAX SPD',
  'ACCELS AT 60% MAX SPD',
  'ACCELS AT 60%+ MAX SPD'];

  
export const DECELS_AT_HEADERS = [
  'DECELS AT 20% MAX SPD',
  'DECELS AT 30% MAX SPD',
  'DECELS AT 40% MAX SPD',
  'DECELS AT 50% MAX SPD',
  'DECELS AT 60% MAX SPD',
  'DECELS AT 60%+ MAX SPD'];
 
// CONDENSED VIEW HEADERS
export const SPEED_HEADERS = [
  'TEAM TARGET SPEED',
  'REL TARGET SPEED',
  'TEAM MAX SPEED',
  'REL MAX SPEED',
  'TEAM MAX SUST. SPEED',
  'REL MAX SUST. SPEED',
  'TEAM TIME SINCE X% OF MAX',
  'REL TIME SINCE X% OF MAX',
  'SPEED'
];
export const CUSTOM_ZONE_LIVE_HEADERS = [
  'CUST TARGET SPEED',
  'CUST MAX SPEED',
  'CUST MAX SUST. SPEED',
  'CUST TIME SINCE X% OF MAX',
  'CUST HARD EFFORT YDS',
  'CUST WALK YDS',
  'CUST JOG YDS',
  'CUST RUN YDS',
  'CUST SPRINT YDS',
  'CUST MAX SPRINT YDS',
  'CUST WALK COUNT',
  'CUST JOG COUNT',
  'CUST RUN COUNT',
  'CUST SPRINT COUNT',
  'CUST MAX SPRINT COUNT'
];
export const DISTANCES_HEADERS = [
  'TOTAL DIST',
  'TEAM HARD EFFORT YDS',
  'REL HARD EFFORT YDS',
  'TEAM WALK YDS',
  'REL WALK YDS',
  'TEAM JOG YDS',
  'REL JOG YDS',
  'TEAM RUN YDS',
  'REL RUN YDS',
  'TEAM SPRINT YDS',
  'REL SPRINT YDS',
  'TEAM MAX SPRINT YDS',
  'REL MAX SPRINT YDS'
];
export const COUNTS_HEADERS = [
  'TEAM WALK COUNT',
  'REL WALK COUNT',
  'TEAM JOG COUNT',
  'REL JOG COUNT',
  'TEAM RUN COUNT',
  'REL RUN COUNT',
  'TEAM SPRINT COUNT',
  'REL SPRINT COUNT',
  'TEAM MAX SPRINT COUNT',
  'REL MAX SPRINT COUNT'
];
export const ACCEL_COUNTS = [
  'ACCEL LOW',
  'ACCEL MED',
  'ACCEL HIGH',
  'MAX STND ACCEL'
];
export const DECEL_COUNTS = [
  'DECEL LOW',
  'DECEL MED',
  'DECEL HIGH',
  'MAX STND DECEL'
];

export const LOAD_METRICS =[
  'CUMULATIVE LOAD',
  'LOAD BIAS'
];
//CONDENSED VIEW ROWS
export const CUSTOM_ZONE_LIVE_ROWS = [
  'targetMPHCustom',
  'maxSpeedMPH',
  'maxSustainedSpeedMPH',
  'lastTimeVelocityTargetHitTsCustom',
  'hardEffortDistCustom',
  'walkYdsCustom',
  'jogYdsCustom',
  'runYdsCustom',
  'sprintYdsCustom',
  'maxSprintYdsCustom',
  'walkCountCustom',
  'jogCountCustom',
  'runCountCustom',
  'sprintCountCustom',
  'maxSprintCountCustom',
];

export const CUSTOM_ZONE_LIVE_ROWS_PERCENTAGES = [
  '',
  'maxSpeedMPHAs%ofTarget_Custom',
  'maxSustSpeedMPHAs%ofTarget_Custom',
  '',
  'historyHardEffortDistanceCustom_%',
  'walkYdsCustom_%',
  'jogYdsCustom_%',
  'runYdsCustom_%',
  'sprintYdsCustom_%',
  'maxSprintYdsCustom_%',
  'walkCountCustom_%',
  'jogCountCustom_%',
  'runCountCustom_%',
  'sprintCountCustom_%',
  'maxSprintCountCustom_%',
];

export const SPEED_ROWS = [
  'targetMPH',
  'targetMPHRelative',
  'maxSpeedMPH',
  'maxSpeedMPHRelative',
  'maxSustainedSpeedMPH',
  'maxSustainedSpeedMPH',
  'lastTimeVelocityTargetHitTs',
  'lastTimeVelocityTargetHitTsRelative',
  'speedMPH'
];
export const SPEED_ROWS_PERCENTAGES =[ //FALTN PORCENTAJES CUSTOM
  ' ',
  ' ',
  'maxSpeedMPHAs%ofTarget',
  'maxSpeedMPHAs%ofTarget_Relative',
  'maxSustSpeedMPHAs%ofTarget',
  'maxSustSpeedMPHAs%ofTarget_Relative',
];
export const DISTANCES_ROWS = [
  'totalDis',
  'hardEffortDist',  
  'hardEffortDistRelative',
  'walkYds',
  'walkYdsRelative',
  'jogYds',
  'jogYdsRelative',
  'runYds',
  'runYdsRelative',
  'sprintYds',
  'sprintYdsRelative',
  'maxSprintYds',
  'maxSprintYdsRelative'
];
export const DISTANCES_ROWS_PERCENTEGES = [
  'historyTotalDistance_%',
  'historyHardEffortDistance_%', 
  'historyHardEffortDistanceRelative_%'
];
export const COUNTS_ROWS = [
  'walkCount',
  'walkCountRelative',
  'jogCount',
  'jogCountRelative',
  'runCount',
  'runCountRelative',
  'sprintCount',
  'sprintCountRelative',
  'maxSprintCount',
  'maxSprintCountRelative'
];
export const COUNTS_ROWS_PERCENTAGES =[
  'walkCount_%',
  'walkCountRelative_%',
  'jogCount_%',
  'jogCountRelative_%',
  'runCount_%',
  'runCountRelative_%',
  'sprintCount_%',
  'sprintCountRelative_%',
  'maxSprintCount_%',
  'maxSprintCountRelative_%'
];
export const ACCEL_COUNTS_ROWS = [
  'accelSlow',
  'accelMed',
  'accelFast',
  'maxSustAccel'
];
export const DECEL_COUNTS_ROWS = [
  'deccelSlow',
  'deccelMed',
  'deccelFast',
  'maxSustDecel'
];

export const LOAD_METRICS_ROWS =[
  'cumulativeBalanceLoad',
  'biasedBalanceLoad'
];

//EXPANDED VIEW ROWS

export const TEAM_ZONE_ROWS = [
  'timeMoving',
  'totalDis',
  'targetMPH',
  'walkYds',
  'jogYds',
  'runYds',
  'sprintYds',
  'maxSprintYds',
  'dist10Plus',
  'walkTime',
  'jogTime',
  'runTime',
  'sprintTime',
  'maxSprintTime',
  'time10Plus',
  'hardEffortDist',
  'walkCount',
  'jogCount',
  'runCount',
  'sprintCount',
  'maxSprintCount'
];

export const PLAYER_RELATIVE_ROWS = [
  'timeMoving',
  'totalDis',
  'targetMPHRelative',
  'walkYdsRelative',
  'jogYdsRelative',
  'runYdsRelative',
  'sprintYdsRelative',
  'maxSprintYdsRelative',
  'walkTimeRelative',
  'jogTimeRelative',
  'runTimeRelative',
  'sprintTimeRelative',
  'maxSprintTimeRelative',
  'hardEffortDistRelative',
  'walkCountRelative',
  'jogCountRelative',
  'runCountRelative',
  'sprintCountRelative',
  'maxSprintCountRelative'
];

export const CUSTOM_ZONE_ROWS = [
  'timeMoving',
  'totalDis',
  'targetMPHCustom',
  'walkYdsCustom',
  'jogYdsCustom',
  'runYdsCustom',
  'sprintYdsCustom',
  'maxSprintYdsCustom',
  'walkTimeCustom',
  'jogTimeCustom',
  'runTimeCustom',
  'sprintTimeCustom',
  'maxSprintTimeCustom',
  'hardEffortDistCustom',
  'walkCountCustom',
  'jogCountCustom',
  'runCountCustom',
  'sprintCountCustom',
  'maxSprintCountCustom'
];

export const TIMING_PEACE_ROWS =[
  'timeTrkd',
  'timeMoving',
  'ypm',
  'actYPS',
  'actMPH',
  'accelPerMin',
  'deccelPerMin',
  'maxSpeedYPS',
  'maxSpeedMPH',
  'explosiveEffort',
  'maxSustainedSpeedYPS',
  'maxSustainedSpeedMPH'
];

export const ACCELS_DECELS_ROWS = [
  'timeTrkd', 
  'timeMoving',
  'totalsAccel',
  'accelSlow',
  'accelMed',
  'accelFast',
  'accelDistSlow',
  'accelDistMed',
  'accelDistFast',
  'totalsDecel', 
  'deccelSlow',
  'deccelMed',
  'deccelFast',
  'deccelDistSlow',
  'deccelDistMed',
  'deccelDistFast',
  'exIndex',
  'zLoad',
  'maxAccel', 
  'maxSustAccel', 
  'maxDecel',
  'maxSustDecel',
  'accCnt20pOfMax',
  'accCnt30pOfMax',
  'accCnt40pOfMax',
  'accCnt50pOfMax',
  'accCnt60pOfMax',
  'accCnt60plusOfMax',
  'decCnt20pOfMax',
  'decCnt30pOfMax',
  'decCnt40pOfMax',
  'decCnt50pOfMax',
  'decCnt60pOfMax',
  'decCnt60plusOfMax'    
];

export const LATERAL_LOAD_HEADERS = [
'CUMULATIVE LOAD',
'LOAD BIAS',
'LEFT LOW LATERAL LOAD',
'LEFT MEDIUM LATERAL LOAD',
'LEFT HIGH LATERAL LOAD',
'RIGHT LOW LATERAL LOAD',
'RIGHT MEDIUM LATERAL LOAD',
'RIGHT HIGH LATERAL LOAD'
];

export const LATERAL_LOAD_ROWS = [
  'cumulativeBalanceLoad',
  'biasedBalanceLoad',
  'leftLowLatLoadCount',
  'leftMedLatLoadCount',
  'leftHighLatLoadCount',
  'rightLowLatLoadCount',
  'rightMedLatLoadCount',
  'rightHighLatLoadCount',
];

export const PLAYERS_DATA = {
  LIVE: 'PLAYERS_DATA_LIVE',
  PAST: 'PLAYERS_DATA_PAST'
};

export const HEADERS = {
  // PRESENT ON LIVE
  name: {
    LABEL: {
      ALL: 'PLAYER',
      LIVE: 'PLAYER'
    },
    KEY: 'name',
    FULL_NAME: {
      ALL: 'Player Display Name',
      LIVE: 'Player Display Name'
    }
  },
  // PRESENT ON LIVE
  jerseyNumber: {
    LABEL: {
      ALL: 'NO.',
      LIVE: 'NO.'
    },
    KEY: 'jerseyNumber',
    FULL_NAME: {
      ALL: 'Player Number',
      LIVE: 'Player Number'
    }
  },
  // PRESENT ON LIVE
  position: {
    LABEL: {
      ALL: 'POS.',
      LIVE: 'POS.'
    },
    KEY: 'position',
    FULL_NAME: {
      ALL: 'Position',
      LIVE: 'Position'
    }
  },
  // TEAM ZONE, TITLE HEADER
  timeMoving: {
    LABEL: {
      ALL: 'TIME MOVING',
      LIVE: ''
    },
    KEY: 'timeMoving',
    FULLPRACTICE_KEY: 'timeMoving',
    FORMAT: 'time',
    FULL_NAME: 'Time Moving'
  },
  // PRESENT ON LIVE
  totalDis: {
    LABEL: {
      ALL: 'TOTAL DIST',
      LIVE: 'TOTAL DIST'
    },
    KEY: 'totalDis',
    FULLPRACTICE_KEY: 'totalDis',
    FORMAT: 0,
    PERCENTAGE_KEY: 'historyTotalDistance_%',
    FULL_NAME: 'Total Distance'
  },
  // PRESENT ON LIVE
  targetMPH: {
    LABEL: {
      ALL: 'TEAM TARGET MPH',
      LIVE: 'TARGET SPEED'
    },
    KEY: 'targetMPH',
    FULL_NAME: {
      ALL: 'Team Target MPH',
      LIVE: 'Target Speed'
    }
  },
  // PRESENT ON LIVE
  walkYds: {
    LABEL: {
      ALL: 'TEAM WALK YDS',
      LIVE: 'WALK'
    },
    KEY: 'walkYds',
    FULLPRACTICE_KEY: 'walkYds',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Walk Yards',
      LIVE: 'Walk'
    }
  },
  // PRESENT ON LIVE
  jogYds: {
    LABEL: {
      ALL: 'TEAM JOG YDS',
      LIVE: 'JOG'
    },
    KEY: 'jogYds',
    FULLPRACTICE_KEY: 'jogYds',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Jog Yards',
      LIVE: 'Jog'
    }
  },
  // PRESENT ON LIVE
  runYds: {
    LABEL: {
      ALL: 'TEAM RUN YDS',
      LIVE: 'RUN'
    },
    KEY: 'runYds',
    FULLPRACTICE_KEY: 'runYds',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Run Yards',
      LIVE: 'Run'
    }
  },
  // PRESENT ON LIVE
  sprintYds: {
    LABEL: {
      ALL: 'TEAM SPRINT YDS',
      LIVE: 'SPRINT'
    },
    KEY: 'sprintYds',
    FULLPRACTICE_KEY: 'sprintYds',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Sprint Yards',
      LIVE: 'Sprint'
    }
  },
  // PRESENT ON LIVE
  maxSprintYds: {
    LABEL: {
      ALL: 'TEAM MAX SPRINT YDS',
      LIVE: 'MAX SPRINT'
    },
    KEY: 'maxSprintYds',
    FULLPRACTICE_KEY: 'maxSprintYds',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Max Sprint Yards',
      LIVE: 'Max Sprint'
    }
  },
  dist10Plus: {
    LABEL: {
      ALL: 'YDS 10+',
      LIVE: ''
    },
    KEY: 'dist10Plus',
    FULLPRACTICE_KEY: 'dist10Plus',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Yards at 10+ MPH',
      LIVE: ''
    }
  },
  walkTime: {
    LABEL: {
      ALL: 'TEAM WALK TIME',
      LIVE: ''
    },
    KEY: 'walkTime',
    FULLPRACTICE_KEY: 'walkTime',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Team Walk Time',
      LIVE: ''
    }
  },
  jogTime: {
    LABEL: {
      ALL: 'TEAM JOG TIME',
      LIVE: ''
    },
    KEY: 'jogTime',
    FULLPRACTICE_KEY: 'jogTime',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Team Jog Time',
      LIVE: ''
    }
  },
  runTime: {
    LABEL: {
      ALL: 'TEAM RUN TIME',
      LIVE: ''
    },
    KEY: 'runTime',
    FULLPRACTICE_KEY: 'runTime',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Team Run Time',
      LIVE: ''
    }
  },
  sprintTime: {
    LABEL: {
      ALL: 'TEAM SPRINT TIME',
      LIVE: ''
    },
    KEY: 'sprintTime',
    FULLPRACTICE_KEY: 'sprintTime',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Team Sprint Time',
      LIVE: ''
    }
  },
  maxSprintTime: {
    LABEL: {
      ALL: 'TEAM MAX SPRINT TIME',
      LIVE: ''
    },
    KEY: 'maxSprintTime',
    FULLPRACTICE_KEY: 'maxSprintTime',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Team Max Sprint Time',
      LIVE: ''
    }
  },
  time10plus: {
    LABEL: {
      ALL: 'TIME 10+',
      LIVE: ''
    },
    KEY: 'time10plus',
    FULLPRACTICE_KEY: 'time10Plus',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Time at 10+ MPH',
      LIVE: ''
    }
  },
  // LATERAL LOAD METRICS
    cumulativeBalanceLoad: {
    LABEL: {
      ALL: 'CUMULATIVE LOAD',
      LIVE: 'CUMULATIVE LOAD'  
    },
    KEY: 'cumulativeBalanceLoad',
    FULLPRACTICE_KEY: 'cumulativeBalanceLoad',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Cumulative Load',
      LIVE: 'Cumulative Load'
    }
  },
    biasedBalanceLoad: {
    LABEL: {
      ALL: 'LOAD BIAS',
      LIVE: 'LOAD BIAS'
    },
    KEY: 'biasedBalanceLoad',
    FULLPRACTICE_KEY: 'biasedBalanceLoad',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Load Bias',
      LIVE: 'Load Bias'
    }
  },
  leftHighLatLoadCount: {
    LABEL: {
      ALL: 'LEFT HIGH LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'leftHighLatLoadCount',
    FULLPRACTICE_KEY: 'leftHighLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Left High Lateral Load Count',
      LIVE: ''
    }
  },
  leftMedLatLoadCount: {
    LABEL: {
      ALL: 'LEFT MEDIUM LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'leftMedLatLoadCount',
    FULLPRACTICE_KEY: 'leftMedLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Left Medium Lateral Load Count',
      LIVE: ''
    }
  },
  leftLowLatLoadCount: {
    LABEL: {
      ALL: 'LEFT LOW LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'leftLowLatLoadCount',
    FULLPRACTICE_KEY: 'leftLowLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Left Low Lateral Load Count',
      LIVE: ''
    }
  },

  rightHighLatLoadCount: {
    LABEL: {
      ALL: 'RIGHT HIGH LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'rightHighLatLoadCount',
    FULLPRACTICE_KEY: 'rightHighLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Right High Lateral Load Count',
      LIVE: ''
    }
  },
  rightMedLatLoadCount: {
    LABEL: {
      ALL: 'RIGHT MEDIUM LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'rightMedLatLoadCount',
    FULLPRACTICE_KEY: 'rightMedLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Right Medium Lateral Load Count',
      LIVE: ''
    }
  },
  rightLowLatLoadCount: {
    LABEL: {
      ALL: 'RIGHT LOW LATERAL LOAD',
      LIVE: ''
    },
    KEY: 'rightLowLatLoadCount',
    FULLPRACTICE_KEY: 'rightLowLatLoadCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Right Low Lateral Load Count',
      LIVE: ''
    }
  },



  // PRESENT ON LIVE
  hardEffortDist: {
    LABEL: {
      ALL: 'TEAM HARD EFFORT DIST',
      LIVE: 'HARD EFF. DIST.'
    },
    KEY: 'hardEffortDist',
    FULLPRACTICE_KEY: 'teamHardEffortDist',
    FORMAT: 0,
    PERCENTAGE_KEY: 'historyHardEffortDistance_%',
    FULL_NAME: {
      ALL: 'Team Hard Effort Distance',
      LIVE: 'Hard Effort Distance'
    }
  },
  sprintCount: {
    LABEL: {
      ALL: 'TEAM SPRINT COUNT',
      LIVE: 'SPRINT COUNT'
    },
    KEY: 'sprintCount',
    FULLPRACTICE_KEY: 'sprintCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Sprint Count',
      LIVE: ''
    }
  },
  maxSprintCount: {
    LABEL: {
      ALL: 'TEAM MAX SPRINT COUNT',
      LIVE: 'MAX SPRINT COUNT'
    },
    KEY: 'maxSprintCount',
    FULLPRACTICE_KEY: 'maxSprintCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Team Max Sprint Count',
      LIVE: ''
    }
  },

  // PLAYER RELATIVE ZONE, TITLE HEADER
  // TIME MOVING AND DIST TOTAL ARE PLACED ON THE TEAM ZONE TITLE HEADER
  targetMPHRelative: {
    LABEL: {
      ALL: 'REL TARGET MPH',
      LIVE: 'REL TARGET MPH'
    },
    KEY: 'targetMPHRelative',
    FULLPRACTICE_KEY: 'targetMPHRelative',
    FORMAT: 1,
    FULL_NAME: {
      ALL: 'Relative Target MPH',
      LIVE: ''
    }
  },
  walkYdsRelative: {
    LABEL: {
      ALL: 'REL WALK DIST.',
      LIVE: 'REL WALK DIST.'
    },
    KEY: 'walkYdsRelative',
    FULLPRACTICE_KEY: 'walkYdsRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Walk Yards',
      LIVE: ''
    }
  },
  jogYdsRelative: {
    LABEL: {
      ALL: 'REL JOG YDS',
      LIVE: 'REL JOG YDS'
    },
    KEY: 'jogYdsRelative',
    FULLPRACTICE_KEY: 'jogYdsRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Jog Yards',
      LIVE: ''
    }
  },
  runYdsRelative: {
    LABEL: {
      ALL: 'REL RUN YDS',
      LIVE: 'REL RUN YDS'
    },
    KEY: 'runYdsRelative',
    FULLPRACTICE_KEY: 'runYdsRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Run Yards',
      LIVE: ''
    }
  },
  sprintYdsRelative: {
    LABEL: {
      ALL: 'REL SPRINT YDS',
      LIVE: 'REL SPRINT YDS'
    },
    KEY: 'sprintYdsRelative',
    FULLPRACTICE_KEY: 'sprintYdsRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Sprint Yards',
      LIVE: ''
    }
  },
  maxSprintYdsRelative: {
    LABEL: {
      ALL: 'REL MAX SPRINT YDS',
      LIVE: 'REL MAX SPRINT YDS'
    },
    KEY: 'maxSprintYdsRelative',
    FULLPRACTICE_KEY: 'maxSprintYdsRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Max Sprint Yards',
      LIVE: ''
    }
  },
  walkTimeRelative: {
    LABEL: {
      ALL: 'REL WALK TIME',
      LIVE: 'REL WALK TIME'
    },
    KEY: 'walkTimeRelative',
    FULLPRACTICE_KEY: 'walkTimeRelative',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Relative Walk Time',
      LIVE: ''
    }
  },
  jogTimeRelative: {
    LABEL: {
      ALL: 'REL JOG TIME',
      LIVE: 'REL JOG TIME'
    },
    KEY: 'jogTimeRelative',
    FULLPRACTICE_KEY: 'jogTimeRelative',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Relative Jog Time',
      LIVE: ''
    }
  },
  runTimeRelative: {
    LABEL: {
      ALL: 'REL RUN TIME',
      LIVE: 'REL RUN TIME'
    },
    KEY: 'runTimeRelative',
    FULLPRACTICE_KEY: 'runTimeRelative',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Relative Run Time',
      LIVE: ''
    }
  },
  sprintTimeRelative: {
    LABEL: {
      ALL: 'REL SPRINT TIME',
      LIVE: 'REL SPRINT TIME'
    },
    KEY: 'sprintTimeRelative',
    FULLPRACTICE_KEY: 'sprintTimeRelative',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Relative Sprint Time',
      LIVE: ''
    }
  },
  maxSprintTimeRelative: {
    LABEL: {
      ALL: 'REL MAX SPRINT TIME',
      LIVE: 'REL MAX SPRINT TIME'
    },
    KEY: 'maxSprintTimeRelative',
    FULLPRACTICE_KEY: 'maxSprintTimeRelative',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Relative Max Sprint Time',
      LIVE: ''
    }
  },
  hardEffortDistRelative: {
    LABEL: {
      ALL: 'REL HARD EFFORT DIST',
      LIVE: 'REL HARD EFFORT DIST'
    },
    KEY: 'hardEffortDistRelative',
    FULLPRACTICE_KEY: 'teamHardEffortDistRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Hard Effort Distance',
      LIVE: ''
    }
  },
  sprintCountRelative: {
    LABEL: {
      ALL: 'REL SPRINT COUNT',
      LIVE: 'REL SPRINT COUNT'
    },
    KEY: 'sprintCountRelative',
    FULLPRACTICE_KEY: 'sprintCountRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Sprint Count',
      LIVE: ''
    }
  },
  maxSprintCountRelative: {
    LABEL: {
      ALL: 'REL MAX SPRINT COUNT',
      LIVE: 'REL MAX SPRINT COUNT'
    },
    KEY: 'maxSprintCountRelative',
    FULLPRACTICE_KEY: 'maxSprintCountRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Relative Max Sprint Count',
      LIVE: ''
    }
  },
  // TIMING AND PACE, TITLE HEADER
  timeTrkd: {
    LABEL: {
      ALL: 'TIME TRACKED',
      LIVE: ''
    },
    KEY: 'timeTrkd',
    FULLPRACTICE_KEY: 'timeTrkd',
    FORMAT: 'time',
    FULL_NAME: {
      ALL: 'Time Tracked',
      LIVE: ''
    }
  },
  // timeMoving is already present at the beggining
  ypm: {
    LABEL: {
      ALL: 'YDS/MIN',
      LIVE: ''
    },
    KEY: 'ypm',
    FULLPRACTICE_KEY: 'yardsPerMin',
    FORMAT: 1,
    FULL_NAME: {
      ALL: 'Yards/Minute',
      LIVE: ''
    }
  },
  actYPS: {
    LABEL: {
      ALL: 'ACT AVG YPS',
      LIVE: ''
    },
    KEY: 'actYPS',
    FULLPRACTICE_KEY: 'actAvgYps',
    FORMAT: 1,
    FULL_NAME: {
      ALL: 'Average Active Speed (YPS)',
      LIVE: ''
    }
  },
  actMPH: {
    LABEL: {
      ALL: 'ACT AVG MPH',
      LIVE: ''
    },
    KEY: 'actMPH',
    FULLPRACTICE_KEY: 'actAvgMph',
    FORMAT: 1,
    FULL_NAME: {
      ALL: 'Average Active Speed (MPH)',
      LIVE: ''
    }
  },
  accelPerMin: {
    LABEL: {
      ALL: 'ACCEL/MIN',
      LIVE: ''
    },
    KEY: 'accelPerMin',
    FULLPRACTICE_KEY: 'accelPerMin',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Accelerations/Minute',
      LIVE: ''
    }
  },
  deccelPerMin: {
    LABEL: {
      ALL: 'DECEL/MIN',
      LIVE: ''
    },
    KEY: 'deccelPerMin',
    FULLPRACTICE_KEY: 'decelPerMin',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Decelerations/Minute',
      LIVE: ''
    }
  },
  maxSpeedYPS: {
    LABEL: {
      ALL: 'MAX YPS',
      LIVE: ''
    },
    KEY: 'maxSpeedYPS',
    FULLPRACTICE_KEY: 'maxSpeedYPS',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Speed (YPS)',
      LIVE: ''
    }
  },
  // PRESENT ON LIVE
  maxSpeedMPH: {
    LABEL: {
      ALL: 'MAX MPH',
      LIVE: 'MAX SPEED'
    },
    KEY: 'maxSpeedMPH',
    FULLPRACTICE_KEY: 'maxMPH',
    FORMAT: 2,
    RELATIVE_KEY: 'maxSpeedMPHAs%ofTarget_Relative',
    ABSOULTE_KEY: 'maxSpeedMPHAs%ofTarget',
    FULL_NAME: {
      ALL: 'Max Speed (MPH)',
      LIVE: 'Max Speed'
    }
  },
  explosiveEffort: {
    LABEL: {
      ALL: 'EXPLOSIVE EFFORT',
      LIVE: ''
    },
    KEY: 'explosiveEffort',
    FULLPRACTICE_KEY: 'explosiveEffort',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Explosive Effort',
      LIVE: ''
    }
  },
  maxSustainedSpeedYPS: {
    LABEL: {
      ALL: 'MAX STND YPS',
      LIVE: ''
    },
    KEY: 'maxSustainedSpeedYPS',
    FULLPRACTICE_KEY: 'maxSustSpeedYPS',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Sustained Speed (YPS)',
      LIVE: ''
    }
  },
  // PRESENT ON LIVE
  maxSustainedSpeedMPH: {
    LABEL: {
      ALL: 'MAX STND MPH',
      LIVE: 'MAX SUST. SPEED'
    },
    KEY: 'maxSustainedSpeedMPH',
    FULLPRACTICE_KEY: 'maxSustMPH',
    FORMAT: 2,
    RELATIVE_KEY: 'maxSustSpeedMPHAs%ofTarget_Relative',
    ABSOULTE_KEY: 'maxSustSpeedMPHAs%ofTarget',
    FULL_NAME: {
      ALL: 'Max Sustained Speed (MPH)',
      LIVE: 'Max Sustained Speed'
    }
  },
  // ACCELS AND DECELS, TITLE HEADER
  // TIME TRACKED AND TIME MOVING ARE ALREADY COUNTED BEFORE THIS TITLE HEADER
  totalAccels: {
    LABEL: {
      ALL: 'TOTAL ACCELS',
      LIVE: ''
    },
    KEY: 'totalAccels',
    FULLPRACTICE_KEY: 'totalAccels',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Total Accelerations',
      LIVE: ''
    }
  },
  // NEW ACCELS AND DECELS
  // ACCELS
  accCnt20pOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 20% MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt20pOfMax',
    FULLPRACTICE_KEY: 'accCnt20pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 20% of Max Speed',
      LIVE: ''
    }
  },
  accCnt30pOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 30% MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt30pOfMax',
    FULLPRACTICE_KEY: 'accCnt30pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 30% of max speed',
      LIVE: ''
    }
  },
  accCnt40pOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 40% MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt40pOfMax',
    FULLPRACTICE_KEY: 'accCnt40pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 40% of max speed',
      LIVE: ''
    }
  },
  accCnt50pOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 50% MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt50pOfMax',
    FULLPRACTICE_KEY: 'accCnt50pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 50% of max speed',
      LIVE: ''
    }
  },
  accCnt60pOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 60% MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt60pOfMax',
    FULLPRACTICE_KEY: 'accCnt60pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 60% of max speed',
      LIVE: ''
    }
  },
  accCnt60plusOfMax: {
    LABEL: {
      ALL: 'ACCELS AT 60%+ MAX SPD',
      LIVE: ''
    },
    KEY: 'accCnt60plusOfMax',
    FULLPRACTICE_KEY: 'accCnt60plusOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Acceleration at 60% plus of max speed',
      LIVE: ''
    }
  },
  // DECELS 
  decCnt20pOfMax: {
    LABEL: {
      ALL: 'DECELS AT 20% MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt20pOfMax',
    FULLPRACTICE_KEY: 'decCnt20pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 20% of Max Speed',
      LIVE: ''
    }
  },
  decCnt30pOfMax: {
    LABEL: {
      ALL: 'DECELS AT 30% MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt30pOfMax',
    FULLPRACTICE_KEY: 'decCnt30pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 30% of Max Speed',
      LIVE: ''
    }
  },
  decCnt40pOfMax: {
    LABEL: {
      ALL: 'DECELS AT 40% MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt40pOfMax',
    FULLPRACTICE_KEY: 'decCnt40pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 40% of Max Speed',
      LIVE: ''
    }
  },
  decCnt50pOfMax: {
    LABEL: {
      ALL: 'DECELS AT 50% MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt50pOfMax',
    FULLPRACTICE_KEY: 'decCnt50pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 50% of Max Speed',
      LIVE: ''
    }
  },
  decCnt60pOfMax: {
    LABEL: {
      ALL: 'DECELS AT 60% MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt60pOfMax',
    FULLPRACTICE_KEY: 'decCnt60pOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 60% of Max Speed',
      LIVE: ''
    }
  },
  decCnt60plusOfMax: {
    LABEL: {
      ALL: 'DECELS AT 60%+ MAX SPD',
      LIVE: ''
    },
    KEY: 'decCnt60plusOfMax',
    FULLPRACTICE_KEY: 'decCnt60plusOfMax',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Deceleration at 60% plus of Max Speed',
      LIVE: ''
    }
  },


  // PRESENT ON LIVE
  accelSlow: {
    LABEL: {
      ALL: 'ACCEL LOW',
      LIVE: 'LOW'
    },
    KEY: 'accelSlow',
    FULLPRACTICE_KEY: 'accelSlow',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Low Acceleration Count',
      LIVE: 'Low'
    }
  },
  // PRESENT ON LIVE
  accelMed: {
    LABEL: {
      ALL: 'ACCEL MED',
      LIVE: 'MED.'
    },
    KEY: 'accelMed',
    FULLPRACTICE_KEY: 'accelMed',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Medium Acceleration Count',
      LIVE: 'Medium'
    }
  },
  // PRESENT ON LIVE
  accelFast: {
    LABEL: {
      ALL: 'ACCEL HIGH',
      LIVE: 'HIGH'
    },
    KEY: 'accelFast',
    FULLPRACTICE_KEY: 'accelFast',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'High Acceleration Count',
      LIVE: 'High'
    }
  },
  accelDistSlow: {
    LABEL: {
      ALL: 'ACL DIST LOW',
      LIVE: ''
    },
    KEY: 'accelDistSlow',
    FULLPRACTICE_KEY: 'accelDistSlow',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in Low Acceleration',
      LIVE: ''
    }
  },
  accelDistMed: {
    LABEL: {
      ALL: 'ACL DIST MED',
      LIVE: ''
    },
    KEY: 'accelDistMed',
    FULLPRACTICE_KEY: 'accelDistMed',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in Medium Acceleration',
      LIVE: ''
    }
  },
  accelDistFast: {
    LABEL: {
      ALL: 'ACL DIST HIGH',
      LIVE: ''
    },
    KEY: 'accelDistFast',
    FULLPRACTICE_KEY: 'accelDistFast',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in High Acceleration',
      LIVE: ''
    }
  },
  accWalkCnt: {
    LABEL: {
      ALL: 'ACL WALK COUNT',
      LIVE: ''
    },
    KEY: 'accWalkCnt',
    FULLPRACTICE_KEY: 'accWalkCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Accel Walk Count',
      LIVE: ''
    }
  },
  accJogCnt: {
    LABEL: {
      ALL: 'ACL JOG COUNT',
      LIVE: ''
    },
    KEY: 'accJogCnt',
    FULLPRACTICE_KEY: 'accJogCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Accel Jog Count',
      LIVE: ''
    }
  },
  accRunCnt: {
    LABEL: {
      ALL: 'ACL RUN COUNT',
      LIVE: ''
    },
    KEY: 'accRunCnt',
    FULLPRACTICE_KEY: 'accRunCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Accel Run Count',
      LIVE: ''
    }
  },
  accSprintCnt: {
    LABEL: {
      ALL: 'ACL SPRINT COUNT',
      LIVE: ''
    },
    KEY: 'accSprintCnt',
    FULLPRACTICE_KEY: 'accSprintCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Accel Sprint Count',
      LIVE: ''
    }
  },
  accMaxSprintCnt: {
    LABEL: {
      ALL: 'ACL MAX SPRINT COUNT',
      LIVE: ''
    },
    KEY: 'accMaxSprintCnt',
    FULLPRACTICE_KEY: 'accMaxSprintCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Accel Max Sprint Count',
      LIVE: ''
    }
  },
  decWalkCnt: {
    LABEL: {
      ALL: 'DCL WALK COUNT',
      LIVE: ''
    },
    KEY: 'decWalkCnt',
    FULLPRACTICE_KEY: 'decWalkCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Decel Walk Count',
      LIVE: ''
    }
  },
  decJogCnt: {
    LABEL: {
      ALL: 'DCL JOG COUNT',
      LIVE: ''
    },
    KEY: 'decJogCnt',
    FULLPRACTICE_KEY: 'decJogCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Decel Jog Count',
      LIVE: ''
    }
  },
  decRunCnt: {
    LABEL: {
      ALL: 'DCL RUN COUNT',
      LIVE: ''
    },
    KEY: 'decRunCnt',
    FULLPRACTICE_KEY: 'decRunCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Decel Run Count',
      LIVE: ''
    }
  },
  decSprintCnt: {
    LABEL: {
      ALL: 'DCL SPRINT COUNT',
      LIVE: ''
    },
    KEY: 'decSprintCnt',
    FULLPRACTICE_KEY: 'decSprintCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Decel Sprint Count',
      LIVE: ''
    }
  },
  decMaxSprintCnt: {
    LABEL: {
      ALL: 'DCL MAX SPRINT COUNT',
      LIVE: ''
    },
    KEY: 'decMaxSprintCnt',
    FULLPRACTICE_KEY: 'decMaxSprintCnt',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Decel Max Sprint Count',
      LIVE: ''
    }
  },
  totalDecels: {
    LABEL: {
      ALL: 'TOTAL DECELS',
      LIVE: ''
    },
    KEY: 'totalDecels',
    FULLPRACTICE_KEY: 'totalDecels',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Total Deceleration Counts',
      LIVE: ''
    }
  },
  // PRESENT ON LIVE
  deccelSlow: {
    LABEL: {
      ALL: 'DECELS LOW',
      LIVE: 'LOW'
    },
    KEY: 'deccelSlow',
    FULLPRACTICE_KEY: 'deccelSlow',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Low Deceleration Counts',
      LIVE: 'Low'
    }
  },
  // PRESENT ON LIVE
  deccelMed: {
    LABEL: {
      ALL: 'DECELS MED',
      LIVE: 'MED.'
    },
    KEY: 'deccelMed',
    FULLPRACTICE_KEY: 'deccelMed',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Medium Deceleration Counts',
      LIVE: 'Medium'
    }
  },
  // PRESENT ON LIVE
  deccelFast: {
    LABEL: {
      ALL: 'DECELS HIGH',
      LIVE: 'HIGH'
    },
    KEY: 'deccelFast',
    FULLPRACTICE_KEY: 'deccelFast',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'High Deceleration Counts',
      LIVE: 'High'
    }
  },
  deccelDistSlow: {
    LABEL: {
      ALL: 'DECEL DIST LOW',
      LIVE: ''
    },
    KEY: 'deccelDistSlow',
    FULLPRACTICE_KEY: 'deccelDistSlow',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in Low Deceleration',
      LIVE: ''
    }
  },
  deccelDistMed: {
    LABEL: {
      ALL: 'DECEL DIST MED',
      LIVE: ''
    },
    KEY: 'deccelDistMed',
    FULLPRACTICE_KEY: 'deccelDistMed',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in Medium Deceleration',
      LIVE: ''
    }
  },
  deccelDistFast: {
    LABEL: {
      ALL: 'DECEL DIST HIGH',
      LIVE: ''
    },
    KEY: 'deccelDistFast',
    FULLPRACTICE_KEY: 'deccelDistFast',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Distance in High Deceleration',
      LIVE: ''
    }
  },
  exIndex: {
    LABEL: {
      ALL: 'EXERTION INDEX',
      LIVE: ''
    },
    KEY: 'exIndex',
    FULLPRACTICE_KEY: 'exIndex',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Exertion Index',
      LIVE: ''
    }
  },
  maxAccel: {
    LABEL: {
      ALL: 'MAX ACCEL',
      LIVE: ''
    },
    KEY: 'maxAccel',
    FULLPRACTICE_KEY: 'maxAccel',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Acceleration',
      LIVE: ''
    }
  },
  maxSustAccel: {
    LABEL: {
      ALL: 'MAX STND ACCEL',
      LIVE: 'MAX STND ACCEL'
    },
    KEY: 'maxSustAccel',
    FULLPRACTICE_KEY: 'maxSustAccel',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Sustained Acceleration',
      LIVE: ''
    }
  },
  maxDecel: {
    LABEL: {
      ALL: 'MAX DECEL',
      LIVE: ''
    },
    KEY: 'maxDecel',
    FULLPRACTICE_KEY: 'maxDecel',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Deceleration',
      LIVE: ''
    }
  },
  maxSustDecel: {
    LABEL: {
      ALL: 'MAX STND DECEL',
      LIVE: 'MAX STND DECEL'
    },
    KEY: 'maxSustDecel',
    FULLPRACTICE_KEY: 'maxSustDecel',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Max Sustained Deceleration',
      LIVE: ''
    }
  },

  walkCountRelative: {
    LABEL: {
      ALL: 'REL WALK COUNT',
      LIVE: 'REL WALK COUNT'
    },
    KEY: 'walkCountRelative',
    FULLPRACTICE_KEY: 'walkCountRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Walk Count Relative',
      LIVE: ''
    }
  },
  jogCountRelative: {
    LABEL: {
      ALL: 'REL JOG COUNT',
      LIVE: 'REL JOG COUNT'
    },
    KEY: 'jogCountRelative',
    FULLPRACTICE_KEY: 'jogCountRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Jog Count Relative',
      LIVE: ''
    }
  },
  runCountRelative: {
    LABEL: {
      ALL: 'REL RUN COUNT',
      LIVE: 'REL RUN COUNT'
    },
    KEY: 'runCountRelative',
    FULLPRACTICE_KEY: 'runCountRelative',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Run Count Relative',
      LIVE: ''
    }
  },
  walkCount: {
    LABEL: {
      ALL: 'TEAM WALK COUNT',
      LIVE: 'WALK COUNT'
    },
    KEY: 'walkCount',
    FULLPRACTICE_KEY: 'walkCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Walk Count',
      LIVE: ''
    }
  },
  jogCount: {
    LABEL: {
      ALL: 'TEAM JOG COUNT',
      LIVE: 'JOG COUNT'
    },
    KEY: 'jogCount',
    FULLPRACTICE_KEY: 'jogCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Jog Count',
      LIVE: ''
    }
  },
  runCount: {
    LABEL: {
      ALL: 'TEAM RUN COUNT',
      LIVE: 'RUN COUNT'
    },
    KEY: 'runCount',
    FULLPRACTICE_KEY: 'runCount',
    FORMAT: 0,
    FULL_NAME: {
      ALL: 'Run Count',
      LIVE: ''
    }
  },
  zLoad: {
    LABEL: {
      ALL: 'PLAYER LOAD',
      LIVE: ''
    },
    KEY: 'zLoad',
    FULLPRACTICE_KEY: 'zLoad',
    FORMAT: 2,
    FULL_NAME: {
      ALL: 'Player Load',
      LIVE: ''
    }
  },

  // FIELDS EXCLUSIVE TO LIVE METRICS
  // PRESENT ON LIVE
  lastTimeVelocityTargetHitTs: {
    LABEL: {
      ALL: '',
      LIVE: 'TIME SINCE X% OF MAX'
    },
    KEY: 'lastTimeVelocityTargetHitTs',
    FULL_NAME: {
      ALL: '',
      LIVE: 'Time since X% of Max'
    }
  },
  //CUSTOM ZONES
  targetMPHCustom: {
  LABEL: {
    ALL: 'CUST TARGET MPH',
    LIVE: 'CUST TARGET MPH'
  },
  KEY: 'targetMPHCustom',
  FULLPRACTICE_KEY: 'targetMPHCustom',
  FORMAT: 1,
  FULL_NAME: {
    ALL: 'Custom Target MPH',
    LIVE: ''
  }
},
walkYdsCustom: {
  LABEL: {
    ALL: 'CUST WALK YDS',
    LIVE: 'CUST WALK YDS'
  },
  KEY: 'walkYdsCustom',
  FULLPRACTICE_KEY: 'walkYdsCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Walk Yards',
    LIVE: ''
  }
},
jogYdsCustom: {
  LABEL: {
    ALL: 'CUST JOG YDS',
    LIVE: 'CUST JOG YDS'
  },
  KEY: 'jogYdsCustom',
  FULLPRACTICE_KEY: 'jogYdsCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Jog Yards',
    LIVE: ''
  }
},
runYdsCustom: {
  LABEL: {
    ALL: 'CUST RUN YDS',
    LIVE: 'CUST RUN YDS'
  },
  KEY: 'runYdsCustom',
  FULLPRACTICE_KEY: 'runYdsCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Run Yards',
    LIVE: ''
  }
},
sprintYdsCustom: {
  LABEL: {
    ALL: 'CUST SPRINT YDS',
    LIVE: 'CUST SPRINT YDS'
  },
  KEY: 'sprintYdsCustom',
  FULLPRACTICE_KEY: 'sprintYdsCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Sprint Yards',
    LIVE: ''
  }
},
maxSprintYdsCustom: {
  LABEL: {
    ALL: 'CUST MAX SPRINT YDS',
    LIVE: 'CUST MAX SPRINT YDS'
  },
  KEY: 'maxSprintYdsCustom',
  FULLPRACTICE_KEY: 'maxSprintYdsCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Max Sprint Yards',
    LIVE: ''
  }
},
walkTimeCustom: {
  LABEL: {
    ALL: 'CUST WALK TIME',
    LIVE: 'CUST WALK TIME'
  },
  KEY: 'walkTimeCustom',
  FULLPRACTICE_KEY: 'walkTimeCustom',
  FORMAT: 'time',
  FULL_NAME: {
    ALL: 'Custom Walk Time',
    LIVE: ''
  }
},
jogTimeCustom: {
  LABEL: {
    ALL: 'CUST JOG TIME',
    LIVE: 'CUST JOG TIME'
  },
  KEY: 'jogTimeCustom',
  FULLPRACTICE_KEY: 'jogTimeCustom',
  FORMAT: 'time',
  FULL_NAME: {
    ALL: 'Custom Jog Time',
    LIVE: ''
  }
},
runTimeCustom: {
  LABEL: {
    ALL: 'CUST RUN TIME',
    LIVE: 'CUST RUN TIME'
  },
  KEY: 'runTimeCustom',
  FULLPRACTICE_KEY: 'runTimeCustom',
  FORMAT: 'time',
  FULL_NAME: {
    ALL: 'Custom Run Time',
    LIVE: ''
  }
},
sprintTimeCustom: {
  LABEL: {
    ALL: 'CUST SPRINT TIME',
    LIVE: 'CUST SPRINT TIME'
  },
  KEY: 'sprintTimeCustom',
  FULLPRACTICE_KEY: 'sprintTimeCustom',
  FORMAT: 'time',
  FULL_NAME: {
    ALL: 'Custom Sprint Time',
    LIVE: ''
  }
},
maxSprintTimeCustom: {
  LABEL: {
    ALL: 'CUST MAX SPRINT TIME',
    LIVE: 'CUST MAX SPRINT TIME'
  },
  KEY: 'maxSprintTimeCustom',
  FULLPRACTICE_KEY: 'maxSprintTimeCustom',
  FORMAT: 'time',
  FULL_NAME: {
    ALL: 'Custom Max Sprint Time',
    LIVE: ''
  }
},
hardEffortDistCustom: {
  LABEL: {
    ALL: 'CUST HARD EFFORT YDS',
    LIVE: 'CUST HARD EFFORT YDS'
  },
  KEY: 'hardEffortDistCustom',
  FULLPRACTICE_KEY: 'teamHardEffortDistCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Hard Effort Distance',
    LIVE: ''
  }
},
walkCountCustom: {
  LABEL: {
    ALL: 'CUST WALK COUNT',
    LIVE: 'CUST WALK COUNT'
  },
  KEY: 'walkCountCustom',
  FULLPRACTICE_KEY: 'walkCountCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Walk Count',
    LIVE: ''
  }
},
jogCountCustom: {
  LABEL: {
    ALL: 'CUST JOG COUNT',
    LIVE: 'CUST JOG COUNT'
  },
  KEY: 'jogCountCustom',
  FULLPRACTICE_KEY: 'jogCountCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Jog Count',
    LIVE: ''
  }
},
runCountCustom: {
  LABEL: {
    ALL: 'CUST RUN COUNT',
    LIVE: 'CUST RUN COUNT'
  },
  KEY: 'runCountCustom',
  FULLPRACTICE_KEY: 'runCountCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Run Count',
    LIVE: ''
  }
},
sprintCountCustom: {
  LABEL: {
    ALL: 'CUST SPRINT COUNT',
    LIVE: 'CUST SPRINT COUNT'
  },
  KEY: 'sprintCountCustom',
  FULLPRACTICE_KEY: 'sprintCountCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Sprint Count',
    LIVE: ''
  }
},
maxSprintCountCustom: {
  LABEL: {
    ALL: 'CUST MAX SPRINT COUNT',
    LIVE: 'CUST MAX SPRINT COUNT'
  },
  KEY: 'maxSprintCountCustom',
  FULLPRACTICE_KEY: 'maxSprintCountCustom',
  FORMAT: 0,
  FULL_NAME: {
    ALL: 'Custom Max Sprint Count',
    LIVE: ''
  }
}

};

// this array gives the keys in the table's index order!
// use this way: pass the index in header, get the key for dictionary use
export const CONDENSED_VIEW_HEADER_KEYS = [
  '', // empty as it is the flag cell index
  'name',
  'jerseyNumber',
  'position',
  'targetMPH',
  'maxSpeedMPH',
  'maxSustainedSpeedMPH',
  'lastTimeVelocityTargetHitTs',
  'totalDis',
  'hardEffortDist',
  'walkYds',
  'jogYds',
  'runYds',
  'sprintYds',
  'maxSprintYds',
  'accelSlow',
  'accelMed',
  'accelFast',
  'maxSustAccel',
  'deccelSlow',
  'deccelMed',
  'deccelFast',
  'maxSustDecel',
  'cumulativeBalanceLoad',
  'biasedBalanceLoad'
];
export const CONDENSED_VIEW_HEADER_COUNTS = [
  'walkCount',
  'jogCount',
  'runCount',
  'sprintCount',
  'maxSprintCount',
];

export const EXPANDED_VIEW_HEADER_KEYS = [
  '',
  'name',
  'jerseyNumber',
  'position',
  'timeMoving',
  'totalDis',
  'targetMPH',
  'walkYds',
  'jogYds',
  'runYds',
  'sprintYds',
  'maxSprintYds',
  'dist10Plus',
  'walkTime',
  'jogTime',
  'runTime',
  'sprintTime',
  'maxSprintTime',
  'time10plus',
  'hardEffortDist',
  'sprintCount',
  'maxSprintCount',
  'timeMoving',
  'totalDis', // REPEATED!!!
  'targetMPHRelative',
  'walkYdsRelative',
  'jogYdsRelative',
  'runYdsRelative',
  'sprintYdsRelative',
  'maxSprintYdsRelative',
  'walkTimeRelative',
  'jogTimeRelative',
  'runTimeRelative',
  'sprintTimeRelative',
  'maxSprintTimeRelative',
  'hardEffortDistRelative',
  'sprintCountRelative',
  'maxSprintCountRelative',
  'timeTrkd',
  'timeMoving',
  'ypm',
  'actYPS',
  'actMPH',
  'accelPerMin',
  'deccelPerMin',
  'maxSpeedYPS',
  'maxSpeedMPH',
  'explosiveEffort',
  'maxSustainedSpeedYPS',
  'maxSustainedSpeedMPH',
  'timeTrkd',
  'timeMoving',
  'totalAccels',
  'accCnt20pOfMax',
  'accCnt30pOfMax',
  'accCnt40pOfMax',
  'accCnt50pOfMax',
  'accCnt60pOfMax',
  'accCnt60plusOfMax',
  'decCnt20pOfMax',
  'decCnt30pOfMax',
  'decCnt40pOfMax',
  'decCnt50pOfMax',
  'decCnt60pOfMax',
  'decCnt60plusOfMax',
  'accelSlow',
  'accelMed',
  'accelFast',
  'accelDistSlow',
  'accelDistMed',
  'accelDistFast',
  'totalDecels',
  'deccelSlow',
  'deccelMed',
  'deccelFast',
  'deccelDistSlow',
  'deccelDistMed',
  'deccelDistFast',
  'exIndex',
  'maxAccel',
  'maxSustAccel',
  'maxDecel',
  'maxSustDecel',
  'cumulativeBalanceLoad',
  'biasedBalanceLoad',
  'leftHighLatLoadCount',
  'leftMedLatLoadCount',
  'leftLowLatLoadCount',
  'rightHighLatLoadCount',
  'rightMedLatLoadCount',
  'rightLowLatLoadCount'
];

/* Map Constants */

export const DEFAULT_FIELD = {
  _id: '1234',
  areaName: 'Default Field',
  image: 'data:image/png;base64,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',
  x0: 0,
  y0: 0,
  x1: 569,
  y1: 274,
  widthFt: 569,
  heightFt: 274,
  dimensions: [569, 274]
};

export const PLAYER_RADIUS = 10;
export const TRAIL_RADIUS = 1;
export const TRAIL_LINE_WIDTH = 2;

export const DEFAULT_LOADING_SECS = 10;
export const LIVE_DEFAULT_LOADING_SECS = 10;

export const LIVE_DELAY_IN_SECS = 25;
export const LIVE_DIFFERENCE_STANDARD = 150; // 30 seconds in decimals
export const BALL_DEFAULT_SIZE = 8;
export const TIMES_SHOULD_FETCH = 18; // 18 times x 10 seconds each = 3 minutes fetching
export const BLINKS_MEMORY_LIMIT = 120; // 120 seconds as limit
export const TRAILS_STORAGE_LIMIT = 600; // one minute secs with decimals
export const FLAGGED_PLAYERS_LIMIT = 10; // 10 players flagged as max

export const LOADING_MESSAGE = 'Fetching Data...';
export const DEFAULT_ERROR_MESSAGE = 'No practice data was found.';
export const SAME_DAY_ERROR_MESSAGE = 'No data found on the current practice minutes.';
export const FLAGS_EXCEED_MESSAGE = 'Sorry, you can only flag 10 players simultaneously.';

export const DEFAULT_TIMELINE_TIME = '00:00:00';

export const DEFAULT_FILTERS_STATE = {
  balls: true,
  jerseys: true,
  positions: false,
  speed: false,
  trails: false
};

export const PLAYERS_CATEGORIE = 'players';
export const STATS_CATEGORIE = 'stats';
export const METRICS_CATEGORIE = 'metrics';
export const OBJECTS_CATEGORIE = 'objects';
export const PLAYERS_TABLE_CATEGORIES = [PLAYERS_CATEGORIE, STATS_CATEGORIE, METRICS_CATEGORIE];

export const TABLE_STATS_COLUMNS = ['TTL DIST.', 'HE DIST.', 'MAX SPEED', 'MAX SUST. SPEED'];
export const TABLE_METRICS_COLUMNS = ['ACCEL MED', 'ACCEL HIGH', 'DECEL MED', 'DECEL HIGH'];

/* End of Map Constants */

export const DEFAULT_PRACTICE_FIELD_ROUTE = '/assets/images/fields/field.svg';
export const DEFAULT_PRACTICE_FIELD_FILENAME = 'field.svg';
export const HEALTH_WAIT_TIME_SLIDER = 1500; // milliseconds
export const CURRENT = 'CURRENT';


// Begin Venue Labels Constants

export const VENUE_LABELS = {
  'ncaa-fbs': {
    practice: {
      '194': 'Ohio State University (194)',
      '2633': 'University of Tennessee (2633)',
      '275': 'University of Wisconsin (275)',
      '2390': 'University of Miami (2390)',
      '9600': 'Senior Bowl - North (9600)',
      '9700': 'Senior Bowl - South (9700)'
    },
    game: {
      '194': 'OSU - Ohio Stadium (194)',
      '2633': 'UT - Neyland Stadium (2633)',
      '9600': 'SBN - Ladd-Peebles Stadium (9600)',
      '9700': 'SBS - Ladd-Peebles Stadium (9700)',
      '36604': 'SB - Ladd-Peebles Stadium (36604)'
    }
  },
  'nfl': {
    practice: {
      '0200': 'ATL (0200)',
      '0810': 'CHI (0810)',
      '1050': 'CLE (1050)',
      '1200': 'DAL (1200)',
      '1540': 'DET (1540)',
      '1800': 'GB (1800)',
      '2510': 'LAR (2510)',
      '2700': 'MIA (2700)',
      '3300': 'NO (3300)',
      '3700': 'PHI (3700)',
      '4500': 'SF (4500)',
      '2100': 'TEN (2100)',
      '9500': 'ZBRA (9500)',
      '2120': 'HOU (2120)',
      '2200': 'IND (2200)',
      '2310': 'KC (2310)',
      '3000': 'MIN (3000)'
    },
    game: {
      '3800': 'ARI - State Farm Stadium (3800)',
      '0200': 'ATL - Mercedes-Benz Stadium (0200)',
      '0325': 'BAL - M&T Bank Stadium (0325)',
      '0610': 'BUF - Bills Stadium (0610)',
      '0750': 'CAR - Bank of America Stadium (0750)',
      '0810': 'CHI - Soldier Field (0810)',
      '0920': 'CIN - Paul Brown Stadium (0920)',
      '1050': 'CLE - FirstEnergy Stadium (1050)',
      '1200': 'DAL - AT&T Stadium (1200)',
      '1400': 'DEN - Empower Field at Mile High (1400)',
      '1540': 'DET - Ford Field (1540)',
      '1800': 'GB - Lambeau Field (1800)',
      '2120': 'HOU - NRG Stadium (2120)',
      '2200': 'IND - Lucas Oil Stadium (2200)',
      '2250': 'JAX - TIAA Bank Field (2250)',
      '2310': 'KC - Arrowhead Stadium (2310)',
      '4400': 'LAC - SoFi Stadium (4400)',
      '2510': 'LAR - SoFi Stadium (2510)',
      '2520': 'LV - Allegiant Stadium (2520)',
      '2700': 'MIA - HardRock Stadium (2700)',
      '3000': 'MIN - U.S. Bank Stadium (3000)',
      '3200': 'NE - Gillette Stadium (3200)',
      '3300': 'NO - Mercedes-Benz Superdome (3300)',
      '3410': 'NYG - MetLife Stadium (3410)',
      '3430': 'NYJ - MetLife Stadium (3430)',
      '3700': 'PHI - Lincoln Financial Field (3700)',
      '3900': 'PIT - Heinz Field (3900)',
      '4500': 'SF - Levi\'s Stadium (4500)',
      '4600': 'SEA - CenturyLink Field (4600)',
      '4900': 'TB - Raymond James Stadium (4900)',
      '2100': 'TEN - Nissan Stadium (2100)',
      '5110': 'WAS - FedEx Field (5110)',
      '1527': 'HI - Aloha Stadium (1527)',
      '2108': 'MEX - Estadio Azteca Stadium (2108)',
      '8600': 'PB - Camping World Stadium (8600)',
      '8700': 'PB2 - Camping World Stadium (8700)',
      '5526': 'TWH - Twickenham Stadium (5526)',
      '5528': 'TOT - Tottenham Stadium (5528)',
      '5525': 'WEM - Wembley Stadium (5525)',
      '5617': 'WPG - Winnipeg Stadium (5617)'
    }
  },
  'ncaa-mlax': {
    practice: {
      '19410': 'OSU MLAX (19410)'
    }
  }
};

// NEW POSITIONS FOR OFFICIAL TYPED ENTITY
export const OFFICIALS_POSITIONS = {
  name: 'Officials Exclusive Positions',
  title: 'POSITION',
  types: [
    { name: 'Back Judge', value: { position: 'Back Judge', group: 'Officials' } },
    { name: 'Down Judge', value: { position: 'Down Judge', group: 'Officials' } },
    { name: 'Field Judge', value: { position: 'Field Judge', group: 'Officials' } },
    { name: 'Line Judge', value: { position: 'Line Judge', group: 'Officials' } },
    { name: 'Referee', value: { position: 'Referee', group: 'Officials' } },
    { name: 'Side Judge', value: { position: 'Side Judge', group: 'Officials' } },
    { name: 'Umpire', value: { position: 'Umpire', group: 'Officials' } },
    { name: 'Alternate', value: { position: 'Alternate', group: 'Officials' } }
  ]
};

// DOES NOT CONTAIN SAVE SCHEDULE ACTION SINCE IT IS SEPARATE IN THE CODE
export const DATAOPS_ACTIONS_DICTIONARY = {
  launchInstance: {
    action: 'init',
    successMessage: 'Instance Launching initiated successfully.',
    errorMessage: 'Instance Launching was not initiaized. Please try again.',
    name: 'Launch Instance',
    serverSuccessMessage: 'action init started'
  },
  retrackInstance: {
    action: 'retrack',
    successMessage: 'Retrack has started successfully.',
    name: 'Retrack Instance',
    errorMessage: 'Retrack Instance was not started. Please try again.',
    serverSuccessMessage: 'action retrack started'
  },
  tretrackInstance: {
    action: 'tretrack',
    successMessage: 'Targeted Retrack has started successfully.',
    name: 'TRetrack Instance',
    errorMessage: 'Targeted Retrack Instance was not started. Please try again.',
    serverSuccessMessage: 'action tretrack started'
  },
  ballFlightRetrack: {
    action: 'ballflightretrack',
    successMessage: 'BallFlight Retrack has started successfully.',
    name: 'BallFlight Retrack',
    errorMessage: 'BallFlight Retrack was not initiated. Please try again.',
    serverSuccessMessage: 'action ballflightretrack started'
  },
  finalizeRetrack: {
    action: 'finalize',
    successMessage: 'Retrack Finalization has started successfully',
    name: 'Finalize Retrack',
    errorMessage: 'Retrack Finalization has not executed correctly. Please try again.',
    serverSuccessMessage: 'action finalize started'
  },
  saveSchedule: {
    action: 'saveschedule',
    successMessage: 'Schedule was Saved successfully',
    name: 'Save Schedule',
    errorMessage: 'Schedule was not Saved. Please try again.',
    serverSuccessMessage: 'wtf'
  },
  default: {
    action: 'init',
    successMessage: 'Instance Launching initiated successfully',
    errorMessage: 'Instance Launching was not initiaized. Please try again.',
    name: 'Launch Instance',
    serverSuccessMessage: 'action init started'
  }
};

export const DEFAULT_PROFILE_VENUE_STATE = { siteId: -1, siteName: '', type: 'practice', teamId: '' };
export const DEFAULT_PRACTICE_AREA_FIELD_STATE = { file: undefined, image: '', _id: '' };
export const DEFAULT_PRACTICE_AREA_STATE = {
  areaName: '',
  fileName: '',
  type: 'indoor',
  lat: undefined,
  lng: undefined,
  areaCoords: [0, 0, 0, 0],
  areaFeetDimensions: [0, 0]
};

export const ADD_ACTION = 'add';
export const EDIT_ACTION = 'edit';

export const PERIOD_START_LABEL = 'startTs';
export const PERIOD_END_LABEL = 'endTs';
export const DEFAULT_PERIODS_VALIDATION_STATE = { [PERIOD_START_LABEL]: {}, [PERIOD_END_LABEL]: {} };

export const EVENT_START_LABEL = 'stTime';
export const EVENT_END_LABEL = 'endTime';
export const DEFAULT_EVENT_VALIDATION_STATE = { [EVENT_START_LABEL]: {}, [EVENT_END_LABEL]: {} };

/* Alert Messages */

export const ON_EXPORT_ALERT = 'Please select a valid export year.';

/* End of Alert Messages */
export const MONTHS_LITERALS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/* Confirmation Modal Config */
export const CONFIRMATION_MODAL_CONFIG = {
  titleClassName: 'm-delete-entity-h',
  bodyClassName: 'm-delete-entity-b',
  actionsClassName: 'm-delete-entity-b',
  confirmClassName: 'm-delete-entity-confirm'
};